export default {
  common: {
    close: "बंद करें"
  },
  splash: {
    tagline: "सिर्फ एक चैटबॉट नहीं — आपकी भलाई के लिए एक सुरक्षित, गर्मजोशी भरा स्थान।",
    welcome: "स्वागत है — आपकी भलाई में हर कदम पर सहायता करना।",
    startButton: "शुरू करने के लिए टैप करें",
    continue: "जारी रखें",
    skip: "इंट्रो छोड़ें",
    loading: "लोड हो रहा है...",
    videoLabel: "मैत्री परिचय वीडियो",
    videoNotSupported: "आपका ब्राउज़र वीडियो टैग का समर्थन नहीं करता।",
    mobileTagline: "मानसिक कल्याण के लिए आपका देखभाल करने वाला साथी।",
    tapToPlay: "वीडियो चलाने के लिए टैप करें"
  },
  navbar: {
    title: "मैत्री",
    feelingDown: "ख़ुशी नहीं है? मैत्री के साथ एक नया साथी खोजें।",
    hello: "नमस्ते, {{name}}",
    home: "होम",
    dashboard: "डैशबोर्ड",
    about: "मैत्री के बारे में",
    analysis: "विश्लेषण",
    settings: "सेटिंग्स",
    talkToCounselor: "स्वास्थ्य सेवा पेशेवरों से बात करें",
    logout: "लॉगआउट"
  },
  dashboard: {
    tab: {
      chatbot: "चैटबॉट",
      chart: "प्रगति",
      todo: "कार्यसूची",
      reminder: "रिमाइंडर",
      dementia: "डिमेंशिया चेकर",
      treasure: "कैम्पस हाइलाइट्स",
      notFound: "टैब नहीं मिला"
    },
    loading: "आपका डैशबोर्ड लोड किया जा रहा है...",
    error: {
      generic: "कुछ गलत हुआ। कृपया पुनः प्रयास करें।",
      sessionCheckFailed: "सेशन जांच विफल:",
      fetchFailed: "डैशबोर्ड डेटा लाने में त्रुटि:",
      updateTodosFailed: "टास्क अपडेट नहीं हो पाए:"
    },
    downloadReport: "रिपोर्ट डाउनलोड करें",
    downloading: "रिपोर्ट बनाई जा रही है..."
  },
  maitriTreasure: {
    title: "गुवाहाटी विश्वविद्यालय का अन्वेषण करें",
    description: "कैंटीन, खाने-पीने की जगहों और कैंपस के हँगआउट स्थानों को खोजें। दोस्तों से मिलें, भोजन का आनंद लें और गुवाहाटी विश्वविद्यालय के जीवंत जीवन का अनुभव करें।",
    faqsTitle: "सामान्य प्रश्न",
    startButton: "अन्वेषण शुरू करें",
    carouselAlt0: "गुवाहाटी विश्वविद्यालय स्थल 1",
    carouselAlt1: "गुवाहाटी विश्वविद्यालय स्थल 2",
    carouselAlt2: "गुवाहाटी विश्वविद्यालय स्थल 3",
    faqs: [
      { question: "मैत्री ट्रेजर क्या है?", answer: "गुवाहाटी विश्वविद्यालय का पता लगाने, इसके कैंटीन, खाने-पीने की जगहों और सामाजिक हँगआउट को खोजने के लिए एक प्लेटफ़ॉर्म।" },
      { question: "कौन भाग ले सकता है?", answer: "गुवाहाटी विश्वविद्यालय के सभी छात्र और कर्मचारी स्वागत योग्य हैं।" },
      { question: "क्या यह मुफ्त है?", answer: "हाँ, इसे पूरी तरह से मुफ्त उपयोग और आनंद के लिए बनाया गया है।" },
      { question: "मैं कैसे शुरू करूं?", answer: "'खजाने की खोज शुरू करें' बटन पर क्लिक करके कैंपस का अन्वेषण शुरू करें।" }
    ]
  },
  todo: {
    title: "मेरे कार्य",
    placeholder: "नया कार्य जोड़ें...",
    maxTasks: "अधिकतम 10 कार्य ही जोड़े जा सकते हैं।",
    empty: "कोई कार्य नहीं है — एक जोड़कर शुरुआत करें।",
    completedAll: "सभी कार्य पूरे हो गए! शानदार काम।",
    add: "जोड़ें",
    updateError: "सर्वर के साथ कार्य समन्वय में त्रुटि हुई।",
    loading: "आपके कार्य लोड किए जा रहे हैं...",
    deleteTask: "क्या आप कार्य '{{title}}' हटाना चाहते हैं?"
  },
  chatbot: {
    welcomeAI: "नमस्ते! मैं वैद्य, आपका AI स्वास्थ्य सहायक हूं। मैं यहां आपके मानसिक स्वास्थ्य मेट्रिक्स, स्क्रीनिंग स्कोर और संज्ञानात्मक कार्य का आकलन करने में मदद करने के लिए हूं। मैं आपसे कुछ प्रश्न पूछूंगा ताकि मैं आपके स्वास्थ्य को बेहतर समझ सकूं। आज आप कैसा महसूस कर रहे हैं?",
    inputPlaceholder: "यहाँ अपना संदेश टाइप करें...",
    sendButton: "भेजें",
    loginPrompt: "कृपया चैट शुरू करने के लिए लॉगिन करें।",
    connectionError: "सर्वर से कनेक्ट करने में त्रुटि।",
    sendError: "क्षमा करें, यह संदेश भेजा नहीं जा सका।",
    loading: "लोड हो रहा है...",
    typing: "बॉट टाइप कर रहा है...",
    empty: "अभी तक कोई संदेश नहीं।",
    retryPrompt: "कनेक्शन समस्या। पुनः प्रयास करने के लिए क्लिक करें।",
    retryMessage: "संदेश विफल। पुनः प्रयास करने के लिए यहाँ क्लिक करें।",
    title: "मैत्री वैद्य",
    description: "यह सहायक आपके संदेशों को स्वचालित रूप से समझता है, संदर्भ का विश्लेषण करता है, और आपकी पसंदीदा भाषा में जवाब देता है। आपकी भाषा पसंद localStorage में सहेजी जाती है, इसलिए ऐप बंद करने के बाद भी यह बनी रहती है।",
    benefitsTitle: "मुख्य लाभ",
    benefit1: "AI प्राकृतिक बातचीत को समझता है और सटीक जवाब देता है।",
    benefit2: "सभी टेक्स्ट को स्वचालित रूप से कार्यों का पता लगाने के लिए संसाधित किया जाता है।",
    benefit3: "आपकी टू-डू सूची आपकी चैट के आधार पर गतिशील रूप से अपडेट होती है।",
    benefit4: "उत्पादकता रुझान दिखाने के लिए चार्ट स्वचालित रूप से रीफ्रेश होते हैं।",
    benefit5: "लॉग इन होने पर उपकरणों में स्मार्ट सत्र सिंकिंग।",
    benefit6: "बहु-भाषा इंटरफेस, स्थायी रूप से याद रखा जाता है।",
    howItHelpsTitle: "यह आपकी कैसे मदद करता है",
    howItHelpsDescription: "बस सामान्य रूप से बात करें। सिस्टम कार्यों, अनुसूचियों, अनुस्मारकों, लक्ष्यों पर नजर रखता है और पृष्ठभूमि में सब कुछ चुपचाप अपडेट करता है। किसी कमांड प्रारूप की आवश्यकता नहीं है।",
    languageTitle: "भाषा पसंद क्यों मायने रखती है",
    languageDescription: "हर जवाब आपकी चयनित भाषा के अनुकूल होता है। आपका इंटरफेस, बॉट संदेश, और टू-डू सारांश एक सुसंगत अनुभव के लिए समान भाषा का अनुसरण करते हैं।",
    sending: "भेज रहे हैं...",
    cognitive: {
      orientationScore: "अभिविन्यास स्कोर",
      memoryScore: "स्मृति स्कोर",
      attentionScore: "ध्यान स्कोर",
      languageScore: "भाषा स्कोर",
      executiveScore: "कार्यकारी स्कोर",
      cognitiveRiskLevel: "संज्ञानात्मक जोखिम स्तर",
      assessmentCreated: "संज्ञानात्मक आकलन सफलतापूर्वक बनाया गया!",
      viewInChart: "प्रगति टैब में अपना संज्ञानात्मक आकलन डेटा देखें।",
      assessmentInfo: "आपका संज्ञानात्मक आकलन सहेजा गया है और चार्ट में दिखाई देगा।",
    },
  },
  chart: {
    emotionalMetrics: "भावनात्मक कल्याण मेट्रिक्स",
    screeningMetrics: "स्क्रीनिंग मूल्यांकन मेट्रिक्स",
    barChart: "बार चार्ट",
    lineChart: "लाइन चार्ट",
    noData: "अभी तक कोई मेट्रिक्स उपलब्ध नहीं है।",
    noMetrics: "प्रदर्शित करने के लिए कोई डेटा उपलब्ध नहीं है।",
    refresh: "रीफ्रेश करें",
    stress: "तनाव",
    happiness: "खुशी",
    anxiety: "चिंता",
    overallMood: "कुल मनोदशा",
    phq9: "PHQ-9",
    gad7: "GAD-7",
    ghq: "GHQ",
    mmse: "MMSE",
    moca: "MoCA",
    ace3: "ACE-III",
    minicog: "Mini-Cog",
    slums: "SLUMS",
    rudas: "RUDAS",
    title: "उपयोगकर्ता मेट्रिक्स",
    dementiaMetrics: "संज्ञानात्मक हानि",
    dementiaRisk: "डिमेंशिया जोखिम",
    cognitiveRisk: "संज्ञानात्मक हानि जोखिम",
    progressReport: "प्रगति रिपोर्ट",
    infoTitle: "मेट्रिक्स अवलोकन",
    infoDescription: "यह चार्ट समय के साथ आपके चयनित मेट्रिक्स को दृश्य रूप से प्रस्तुत करता है। आप भावनात्मक मेट्रिक्स, स्क्रीनिंग आकलन, और संज्ञानात्मक हानि जोखिम के बीच टॉगल कर सकते हैं। रुझान देखने के लिए अपना पसंदीदा चार्ट प्रकार (बार या लाइन) चुनें।",
    definitions: "परिभाषाएं",
    stressDefinition: "मनोवैज्ञानिक और शारीरिक तनाव का माप (0-50)। उच्च स्कोर बढ़े हुए तनाव स्तर को दर्शाता है, जो आपके समग्र कल्याण को प्रभावित कर सकता है।",
    happinessDefinition: "सकारात्मक भावनाओं, संतुष्टि और खुशी का माप (0-50)। उच्च स्कोर अधिक खुशी और जीवन संतुष्टि को दर्शाता है।",
    anxietyDefinition: "चिंता, घबराहट और बेचैनी का माप (0-50)। उच्च स्कोर बढ़े हुए चिंता स्तर को दर्शाता है जिस पर ध्यान देने की आवश्यकता हो सकती है।",
    overallMoodDefinition: "आपकी सामान्य भावनात्मक स्थिति का एक समग्र माप (0-50)। यह किसी दिए गए समय में आपके समग्र मनोवैज्ञानिक कल्याण को दर्शाता है।",
    phq9Definition: "रोगी स्वास्थ्य प्रश्नावली-9 (0-27)। एक मान्यता प्राप्त 9-आइटम अवसाद स्क्रीनिंग उपकरण। स्कोर: 0-4 (न्यूनतम), 5-9 (हल्का), 10-14 (मध्यम), 15-19 (मध्यम रूप से गंभीर), 20-27 (गंभीर)।",
    gad7Definition: "सामान्यीकृत चिंता विकार-7 (0-21)। एक 7-आइटम चिंता स्क्रीनिंग पैमाना। स्कोर: 0-4 (न्यूनतम), 5-9 (हल्का), 10-14 (मध्यम), 15-21 (गंभीर चिंता)।",
    ghqDefinition: "सामान्य स्वास्थ्य प्रश्नावली (0-36)। मानसिक स्वास्थ्य स्थिति को मापने वाला एक व्यापक मनोवैज्ञानिक संकट स्क्रीनिंग उपकरण। उच्च स्कोर अधिक मनोवैज्ञानिक संकट को दर्शाता है।",
    dementiaRiskDefinition: "संज्ञानात्मक हानि के लिए जोखिम स्तर को दर्शाने वाला एक प्रतिशत स्कोर (0-100%)। व्यापक गेम-आधारित संज्ञानात्मक मेट्रिक्स पर आधारित जिसमें भारित डोमेन स्कोरिंग (मेमोरी 30%, भाषा 20%, ध्यान 20%, अभिविन्यास 15%, कार्यकारी 15%) शामिल है। कम स्कोर बेहतर संज्ञानात्मक कार्य को दर्शाता है।",
    howScoringWorks: "भावनात्मक मेट्रिक्स कैसे स्कोर और मूल्यांकन किए जाते हैं",
    scoringMethodology: "स्कोरिंग पद्धति",
    emotionalScoringExplanation: "भावनात्मक मेट्रिक्स उन्नत प्राकृतिक भाषा प्रसंस्करण (NLP) तकनीकों का उपयोग करके गणना की जाती है जो चैटबॉट के साथ आपके बातचीत पैटर्न का विश्लेषण करती है। सिस्टम मनोभाषाई मार्कर (LIWC सुविधाएं) का उपयोग करता है जिसमें प्रथम-व्यक्ति सर्वनाम उपयोग आवृत्ति, नकारात्मक भावना शब्द घनत्व, संज्ञानात्मक प्रसंस्करण शब्द आवृत्ति, अशुद्धि मार्कर ('um', 'uh' जैसे हिचकिचाहट शब्द), और पुनरावृत्ति पैटर्न शामिल हैं। इसके अतिरिक्त, ट्रांसफॉर्मर-आधारित एम्बेडिंग (मानसिक-स्वास्थ्य डेटासेट पर फाइन-ट्यून किए गए Sentence-BERT/DistilBERT मॉडल) का उपयोग नैदानिक लक्षण विवरणों के साथ शब्दार्थ समानता को पकड़ने के लिए किया जाता है। स्कोर 0-50 की सीमा में होते हैं, जहां उच्च मान उस भावनात्मक स्थिति की मजबूत उपस्थिति को दर्शाते हैं।",
    evaluationProcess: "मूल्यांकन प्रक्रिया",
    emotionalEvaluationProcess: "AI आपके बातचीत इतिहास का बैचों में विश्लेषण करता है, पैटर्न, दोहराए गए उल्लेखों, और संचयी भावनात्मक संकेतकों की तलाश करता है। प्रत्येक मेट्रिक स्वतंत्र रूप से गणना की जाती है: तनाव स्तर तनावकर्ताओं, शारीरिक लक्षणों, और तनाव संकेतकों के उल्लेखों के माध्यम से पहचाने जाते हैं। खुशी सकारात्मक भावनाओं, संतुष्टि अभिव्यक्तियों, और आनंद संकेतकों के माध्यम से मापी जाती है। चिंता चिंता पैटर्न, घबराहट मार्कर, बेचैनी संकेतकों, और घबराहट-संबंधी भाषा के माध्यम से पता लगाया जाता है। समग्र मनोदशा एक समग्र माप है जो उपरोक्त मेट्रिक्स का औसत हो सकता है या सामान्य भावनात्मक स्थिति का स्वतंत्र आकलन हो सकता है।",
    howScreeningScored: "स्क्रीनिंग मेट्रिक्स कैसे स्कोर और मूल्यांकन किए जाते हैं",
    screeningMethodology: "स्कोरिंग पद्धति",
    screeningScoringExplanation: "PHQ-9, GAD-7, और GHQ स्कोर AI-अनुमानित प्रॉक्सी संकेतक हैं जो बातचीत पैटर्न और भाषाई सुविधाओं का विश्लेषण करके गणना किए जाते हैं। AI उन लक्षणों और व्यवहारों की पहचान करता है जो मानकीकृत प्रश्नावली आइटमों से मेल खाते हैं। PHQ-9 के लिए, सिस्टम रुचि हानि, मनोदशा परिवर्तन, नींद में गड़बड़ी, ऊर्जा स्तर, भूख में परिवर्तन, एकाग्रता समस्याओं, आत्म-मूल्य चिंताओं, गति समस्याओं, और आत्मघाती विचारों के संकेतकों की तलाश करता है। GAD-7 के लिए, यह अत्यधिक चिंता, बेचैनी, थकान, एकाग्रता समस्याओं, चिड़चिड़ापन, मांसपेशियों में तनाव, और नींद की समस्याओं की पहचान करता है। GHQ के लिए, यह मनोवैज्ञानिक संकट, सामाजिक कार्य, और शारीरिक लक्षणों का आकलन करता है। ये स्कोर बातचीत पैटर्न के आधार पर संभावना की भविष्यवाणी करते हैं लेकिन वास्तविक प्रश्नावली प्रतिक्रियाएं नहीं हैं।",
    importantNote: "महत्वपूर्ण नोट",
    screeningImportantNote: "ये AI-अनुमानित स्कोर स्क्रीनिंग उपकरण हैं जो संभावित चिंताओं की पहचान करने में मदद करते हैं। वे आपकी बातचीत के प्राकृतिक भाषा विश्लेषण पर आधारित हैं और सावधानी के साथ व्याख्या की जानी चाहिए। सत्यापित नैदानिक परिणामों और औपचारिक निदान के लिए, आपको स्वास्थ्य देखभाल पेशेवरों द्वारा प्रशासित वास्तविक मानकीकृत PHQ-9, GAD-7, या GHQ प्रश्नावली पूरी करनी होगी। ये प्रॉक्सी स्कोर जागरूकता बढ़ाने और संकेत मिलने पर पेशेवर परामर्श को प्रोत्साहित करने के लिए डिज़ाइन किए गए हैं।",
    howCognitiveScored: "संज्ञानात्मक मेट्रिक्स कैसे स्कोर और मूल्यांकन किए जाते हैं",
    gameBasedScoring: "गेम-आधारित आकलन स्कोरिंग",
    cognitiveScoringExplanation: "संज्ञानात्मक मेट्रिक्स विभिन्न संज्ञानात्मक गेमों में आपके प्रदर्शन से गणना की जाती है। प्रत्येक गेम मान्यता प्राप्त न्यूरोसाइकोलॉजिकल परीक्षण प्रतिमानों के आधार पर विशिष्ट संज्ञानात्मक डोमेन का आकलन करने के लिए डिज़ाइन किया गया है। प्रत्येक गेम से आपके कच्चे स्कोर को निष्पक्ष तुलना सुनिश्चित करने के लिए कठिनाई स्तर (आसान, मध्यम, कठिन) द्वारा सामान्यीकृत किया जाता है। उपयोग किया गया सूत्र है: सामान्यीकृत स्कोर = (कच्चा स्कोर / कठिनाई के लिए अधिकतम संभव स्कोर) × 100। यह सामान्यीकरण विभिन्न कठिनाई गुणकों (आसान: 1.0x, मध्यम: 1.5x, कठिन: 2.0x) को ध्यान में रखता है और सुनिश्चित करता है कि स्कोर गेम और कठिनाई स्तरों में तुलनीय हैं।",
    domainMapping: "गेम-से-डोमेन मैपिंग",
    domainMappingExplanation: "प्रत्येक गेम नैदानिक औचित्य के साथ विशिष्ट संज्ञानात्मक डोमेन से मैप करता है: डिजिट स्पैन और N-Back मुख्य रूप से मेमोरी (कार्यशील मेमोरी क्षमता) का परीक्षण करते हैं। पैटर्न रिकॉल और मेमोरी मैच मेमोरी और ध्यान का आकलन करते हैं। रिएक्शन टाइम ध्यान और प्रसंस्करण गति को मापता है। स्ट्रूप टेस्ट कार्यकारी कार्य (संज्ञानात्मक लचीलापन और निषेध) का मूल्यांकन करता है। क्लॉक ड्राइंग कार्यकारी कार्य, अभिविन्यास, और दृश्य-स्थानिक क्षमताओं का परीक्षण करता है। टेक्स्ट रिकॉल (डिमेंशिया चेकर) मेमोरी और भाषा का आकलन करता है। प्रत्येक गेम भारित महत्व के साथ डोमेन स्कोर में योगदान देता है जो इस बात पर आधारित है कि यह मुख्य रूप से किस संज्ञानात्मक कार्य का परीक्षण करता है।",
    weightedRiskCalculation: "भारित जोखिम स्कोर गणना",
    weightedRiskExplanation: "अंतिम संज्ञानात्मक जोखिम स्कोर नैदानिक अनुसंधान पर आधारित भारित डोमेन मॉडल का उपयोग करता है: मेमोरी (30% भार) - मुख्य प्रारंभिक डिमेंशिया मार्कर, भाषा (20%) - शब्द-खोज समस्याएं जल्दी दिखाई देती हैं, ध्यान (20%) - कार्यकारी गिरावट ध्यान को प्रभावित करती है, अभिविन्यास (15%) - मध्यम प्रभाव, कार्यकारी कार्य (15%) - महत्वपूर्ण लेकिन आमतौर पर देर से चरण मार्कर। सूत्र गणना करता है: भारित जोखिम स्कोर = Σ(डोमेन जोखिम × डोमेन भार), जहां डोमेन जोखिम = 1 - (डोमेन स्कोर / 10)। उच्च डोमेन स्कोर (0-10 पैमाने) बेहतर संज्ञानात्मक कार्य को दर्शाते हैं, जिसके परिणामस्वरूप कम जोखिम स्कोर (0-1 पैमाने) होते हैं। जोखिम स्तर निर्धारित किए जाते हैं: उच्च (≥70%), मध्यम (40-69%), कम (<40%)।",
    whatEachGameTests: "प्रत्येक गेम क्या परीक्षण करता है",
    digitSpanGame: "डिजिट स्पैन",
    digitSpanGameDesc: "आपको अंकों के अनुक्रमों को याद रखने और याद करने की आवश्यकता के द्वारा कार्यशील मेमोरी क्षमता का परीक्षण करता है। तत्काल मेमोरी स्पैन को मापता है, जो संज्ञानात्मक स्वास्थ्य का एक प्रमुख संकेतक है। प्रारंभिक अल्जाइमर रोग अल्पकालिक याद को प्रभावित करता है, जिससे यह परीक्षण प्रारंभिक संज्ञानात्मक गिरावट के प्रति संवेदनशील हो जाता है।",
    nBackGame: "N-Back",
    nBackGameDesc: "आपको एक अनुक्रम में N कदम पीछे दिखाई देने वाली वस्तुओं की पहचान करने की आवश्यकता के द्वारा कार्यशील मेमोरी और कार्यकारी कार्य का मूल्यांकन करता है। कार्यशील मेमोरी में जानकारी को बनाए रखने और अपडेट करने की आपकी क्षमता का परीक्षण करता है, जो हल्के संज्ञानात्मक हानि (MCI) गिरावट के प्रति संवेदनशील है।",
    patternRecallGame: "पैटर्न रिकॉल",
    patternRecallGameDesc: "आपको दृश्य पैटर्न को याद रखने और पुन: उत्पादन करने की आवश्यकता के द्वारा दृश्य मेमोरी और अनुक्रमिक प्रसंस्करण का परीक्षण करता है। मेमोरी एन्कोडिंग और पुनर्प्राप्ति घाटे का मूल्यांकन करता है, जो महत्वपूर्ण संज्ञानात्मक कार्य हैं जो प्रारंभिक-चरण डिमेंशिया में गिरते हैं।",
    memoryMatchGame: "मेमोरी मैच",
    memoryMatchGameDesc: "आपको उनकी स्थिति याद रखकर कार्डों के जोड़े मिलाने की आवश्यकता के द्वारा साहचर्य मेमोरी का आकलन करता है। हिप्पोकैम्पल-निर्भर मेमोरी सिस्टम का परीक्षण करता है, जो प्रारंभिक अल्जाइमर रोग में दृढ़ता से प्रभावित होते हैं। दृश्य मेमोरी घाटे और स्थानिक प्रसंस्करण समस्याओं की पहचान करता है।",
    reactionTimeGame: "रिएक्शन टाइम",
    reactionTimeGameDesc: "दृश्य उत्तेजनाओं के लिए त्वरित प्रतिक्रियाओं की आवश्यकता के द्वारा प्रसंस्करण गति और ध्यान को मापता है। धीमी संज्ञानात्मक प्रसंस्करण का पता लगाता है, जो संज्ञानात्मक गिरावट का एक प्रारंभिक संकेतक है। औसत प्रतिक्रिया समय, परिवर्तनशीलता, और सबसे धीमी 10% प्रतिक्रियाओं को ट्रैक करता है।",
    colorSequenceGame: "रंग अनुक्रम",
    colorSequenceGameDesc: "आपको क्रम में रंग अनुक्रमों को याद रखने और दोहराने की आवश्यकता के द्वारा अनुक्रमिक मेमोरी का परीक्षण करता है। कार्यशील मेमोरी और कार्यकारी कार्य घटकों का मूल्यांकन करता है जो प्रारंभिक डिमेंशिया में प्रभावित होते हैं। मेमोरी में अनुक्रमों को बनाए रखने की क्षमता को मापता है।",
    stroopTestGame: "स्ट्रूप टेस्ट",
    stroopTestGameDesc: "आपको विरोधाभासी पाठ रंगों को नजरअंदाज करते हुए रंग नामों की पहचान करने की आवश्यकता के द्वारा संज्ञानात्मक लचीलापन और निषेध का आकलन करता है। कार्यकारी कार्य और संज्ञानात्मक नियंत्रण को मापता है, जो डिमेंशिया रोगियों में बिगड़ा हुआ है। स्वचालित प्रतिक्रियाओं को रोकने की क्षमता का परीक्षण करता है।",
    clockDrawingGame: "क्लॉक ड्राइंग",
    clockDrawingGameDesc: "डिमेंशिया के लिए व्यापक रूप से उपयोग किया जाने वाला स्क्रीनिंग उपकरण जो दृश्य-स्थानिक कौशल, कार्यकारी कार्य, ध्यान, और शब्दार्थ मेमोरी सहित कई संज्ञानात्मक डोमेन का आकलन करता है। यह एक नैदानिक रूप से मान्यता प्राप्त परीक्षण (CDT) है जिसका उपयोग MMSE, MoCA, और अन्य आकलनों में किया जाता है। क्लॉक ड्राइंग में हानि संज्ञानात्मक गिरावट के मजबूत संकेतक हैं।",
    textRecallGame: "टेक्स्ट रिकॉल",
    textRecallGameDesc: "आपको पाठ अंशों को पढ़ने और याद करने की आवश्यकता के द्वारा मेमोरी और भाषा का मूल्यांकन करता है। मौखिक मेमोरी, भाषा समझ, और प्रतिधारण क्षमता का परीक्षण करता है। प्रारंभिक अल्जाइमर की विशेषता में मेमोरी और भाषा घाटे शामिल हैं, जिससे यह परीक्षण प्रारंभिक पहचान के लिए अत्यधिक प्रासंगिक हो जाता है।",
    primaryDomain: "प्राथमिक डोमेन",
    secondaryDomain: "द्वितीयक",
    importantDisclaimer: "महत्वपूर्ण अस्वीकरण",
    disclaimerTitle: "आकलन उद्देश्य",
    disclaimerText1: "ये संज्ञानात्मक आकलन केवल स्क्रीनिंग और आत्म-मूल्यांकन उद्देश्यों के लिए डिज़ाइन किए गए हैं। वे मान्यता प्राप्त न्यूरोसाइकोलॉजिकल परीक्षण प्रतिमानों पर आधारित हैं लेकिन पेशेवर चिकित्सा मूल्यांकन, निदान, या उपचार को प्रतिस्थापित करने के लिए अभिप्रेत नहीं हैं।",
    disclaimerTitle2: "नैदानिक व्याख्या",
    disclaimerText2: "परिणामों की व्याख्या योग्य स्वास्थ्य देखभाल पेशेवरों द्वारा व्यापक नैदानिक आकलन, चिकित्सा इतिहास, और उपयुक्त नैदानिक परीक्षण के साथ मिलकर की जानी चाहिए। स्कोर थकान, तनाव, दवा प्रभाव, या अस्थायी स्वास्थ्य स्थितियों जैसे कारकों से प्रभावित हो सकते हैं।",
    disclaimerTitle3: "निदान नहीं",
    disclaimerText3: "प्लेटफ़ॉर्म चिकित्सा निदान, उपचार सिफारिशें, या नैदानिक निर्णय-निर्माण सहायता प्रदान नहीं करता है। किसी भी चिकित्सा चिंताओं या स्वास्थ्य-संबंधी निर्णय लेने से पहले हमेशा लाइसेंस प्राप्त स्वास्थ्य देखभाल पेशेवरों से परामर्श करें।",
    proxyDisclaimer: "AI-अनुमानित प्रॉक्सी स्कोर",
    proxyDisclaimerText: "यहां दिखाए गए PHQ-9, GAD-7, और GHQ स्कोर बातचीत पैटर्न पर आधारित AI-अनुमानित प्रॉक्सी संकेतक हैं, वास्तविक प्रश्नावली प्रतिक्रियाएं नहीं हैं। सत्यापित नैदानिक परिणामों के लिए, उपयोगकर्ताओं को मानकीकृत प्रश्नावली पूरी करनी होगी।",
    aiEstimated: "AI-अनुमानित",
    emotionalMetricsDisclaimer: "AI-अनुमानित मेट्रिक्स",
    emotionalMetricsDisclaimerText: "भावनात्मक मेट्रिक्स (तनाव, चिंता, खुशी) मनोभाषाई मार्कर (LIWC सुविधाएं: प्रथम-व्यक्ति उपयोग, नकारात्मक भावना शब्द, संज्ञानात्मक प्रसंस्करण शब्द) और ट्रांसफॉर्मर एम्बेडिंग (मानसिक-स्वास्थ्य डेटासेट पर फाइन-ट्यून किए गए Sentence-BERT/DistilBERT) का उपयोग करके AI-अनुमानित हैं, नैदानिक रूप से मान्यता प्राप्त नैदानिक उपकरण नहीं हैं।",
    cognitiveAssessmentDisclaimer: "संज्ञानात्मक स्कोर बातचीत भाषाई सुविधाओं (मेमोरी मार्कर, अभिविन्यास मार्कर, ध्यान मार्कर, भाषा मार्कर, कार्यकारी कार्य मार्कर) से अनुमानित हैं, औपचारिक न्यूरोसाइकोलॉजिकल परीक्षण नहीं।",
    noDataTitle: "कोई डेटा उपलब्ध नहीं",
    refreshing: "रीफ्रेश हो रहा है...",
    average: "औसत",
    maximum: "अधिकतम",
    minimum: "न्यूनतम",
    dataPoints: "डेटा बिंदु",
    metricType: "मेट्रिक प्रकार",
    chartType: "चार्ट प्रकार",
    infoSubtitle: "अपने मानसिक स्वास्थ्य और संज्ञानात्मक कल्याण को ट्रैक करें",
    feature1Title: "रीयल-टाइम ट्रैकिंग",
    feature1Desc: "समय के साथ परिवर्तनों की निगरानी करें",
    feature2Title: "कई मेट्रिक्स",
    feature2Desc: "भावनात्मक, स्क्रीनिंग और संज्ञानात्मक",
    feature3Title: "दृश्य अंतर्दृष्टि",
    feature3Desc: "बार और लाइन चार्ट विकल्प",
    feature4Title: "ऑटो रीफ्रेश",
    feature4Desc: "नवीनतम डेटा के साथ अपडेट रहें",
    domainWeights: "डोमेन भार",
    memoryWeightReason: "मुख्य प्रारंभिक डिमेंशिया मार्कर - हिप्पोकैम्पल-निर्भर",
    languageWeightReason: "अल्जाइमर में शब्द-खोज समस्याएं जल्दी दिखाई देती हैं",
    attentionWeightReason: "कार्यकारी गिरावट ध्यान नेटवर्क को प्रभावित करती है",
    orientationWeightReason: "मध्यम प्रभाव, बाद के चरणों में अधिक प्रभावित",
    executiveWeightReason: "महत्वपूर्ण लेकिन आमतौर पर देर से चरण मार्कर",
    reactionTimeDefinition: "प्रसंस्करण गति और ध्यान को मापता है। औसत प्रतिक्रिया समय, परिवर्तनशीलता, और सबसे धीमी 10% मुख्य संकेतक हैं। कम समय बेहतर संज्ञानात्मक कार्य को दर्शाता है।",
    accuracyDefinition: "समग्र संज्ञानात्मक दक्षता को सही प्रतिशत के रूप में मापा जाता है। त्रुटि प्रकारों और समय के दबाव में सटीकता को ट्रैक करता है। उच्च सटीकता बेहतर संज्ञानात्मक कार्य को दर्शाती है।",
    workingMemoryDefinition: "अल्पकालिक मेमोरी क्षमता। याद किए गए अधिकतम अनुक्रम, आगे बनाम पीछे स्पैन, और घुसपैठ त्रुटियों को मापता है। उच्च स्पैन बेहतर कार्यशील मेमोरी को दर्शाता है।",
    executiveFunctionDefinition: "निर्णय लेने, योजना बनाने, और निषेध क्षमताएं। कार्य-स्विचिंग गति, नियम उल्लंघन, और दृढ़ता को ट्रैक करता है। कम समय और कम उल्लंघन बेहतर कार्यकारी कार्य को दर्शाते हैं।",
    visuospatialDefinition: "स्थानिक तर्क और दृश्य प्रसंस्करण। आकृतियों को पुनर्निर्माण करने में सटीकता, नेविगेशन त्रुटियों, और पहेली पूर्णता समय को मापता है। उच्च सटीकता बेहतर दृश्य-स्थानिक कार्य को दर्शाती है।",
    attentionDefinition: "निरंतर ध्यान और फोकस। कार्य पर समय, विकर्षक क्लिक दर, चूकी गई उत्तेजनाओं, और स्थिरता स्कोर को ट्रैक करता है। उच्च स्थिरता बेहतर ध्यान को दर्शाती है।",
    processingSpeedDefinition: "संज्ञानात्मक प्रसंस्करण की गति। औसत गेम पूर्णता समय, सबसे तेज़ और सबसे धीमी गेम समय, और गति स्थिरता को मापता है। कम समय तेज़ प्रसंस्करण को दर्शाता है।",
    learningCurveDefinition: "समय के साथ सीखने और सुधार करने की क्षमता। पहले से अंतिम परीक्षण में सुधार, भूलने वाला वक्र, और प्रतिधारण दर को मापता है। सकारात्मक सुधार बेहतर सीखने की क्षमता को दर्शाता है।",
    errorAnalyticsDefinition: "त्रुटि पैटर्न और प्रकार। कुल त्रुटियों, दोहराई गई त्रुटि दर (दृढ़ता), और त्रुटि वर्गीकरण को ट्रैक करता है। कम त्रुटि दर बेहतर संज्ञानात्मक कार्य को दर्शाती है।",
    mmseDefinition: "मिनी-मेंटल स्टेट परीक्षा। एक 30-बिंदु प्रश्नावली जो अभिविन्यास (10), स्मृति (3), ध्यान (5), भाषा (8), और दृश्य-स्थानिक कौशल (4) का आकलन करती है। स्कोर: 24-30 (सामान्य), 18-23 (हल्की हानि), 0-17 (गंभीर हानि)।",
    mocaDefinition: "मॉन्ट्रियल संज्ञानात्मक आकलन। हल्की संज्ञानात्मक हानि का पता लगाता है। ध्यान (6), कार्यकारी कार्य (5), स्मृति (5), भाषा (6), दृश्य-स्थानिक कौशल (5), और अभिविन्यास (3) का मूल्यांकन करता है। सामान्य: ≥26, हल्की हानि: 18-25, गंभीर: <18।",
    ace3Definition: "एडेनब्रुक संज्ञानात्मक परीक्षा-III। व्यापक आकलन जो ध्यान (18), स्मृति (26), प्रवाह (14), भाषा (26), और दृश्य-स्थानिक क्षमताओं (16) का मूल्यांकन करता है। प्रारंभिक अवस्था की संज्ञानात्मक गिरावट के प्रति विशेष रूप से संवेदनशील।",
    minicogDefinition: "संक्षिप्त 3-मिनट स्क्रीनिंग जो तीन-आइटम याद (3 अंक) को घड़ी ड्राइंग परीक्षण (2 अंक) के साथ जोड़ती है। डिमेंशिया का पता लगाने के लिए प्रभावी। स्कोर <3 संज्ञानात्मक हानि का सुझाव देता है।",
    slumsDefinition: "सेंट लुइस यूनिवर्सिटी मानसिक स्थिति परीक्षा। हल्की संज्ञानात्मक हानि और डिमेंशिया का पता लगाने के लिए स्क्रीनिंग उपकरण। अभिविन्यास (4), स्मृति (5), ध्यान (5), कार्यकारी कार्य (6), और भाषा (10) का आकलन करता है।",
    rudasDefinition: "रोलैंड यूनिवर्सल डिमेंशिया आकलन स्केल। सांस्कृतिक और शैक्षिक रूप से निष्पक्ष संज्ञानात्मक स्क्रीनिंग जो स्मृति (8), शरीर अभिविन्यास (6), प्रैक्सिस (5), दृश्य-निर्माण ड्राइंग (4), निर्णय (4), और भाषा (3) का आकलन करती है।",
    assessmentTools: "आकलन उपकरण",
    assessmentToolsDefinition: "हमारा प्लेटफॉर्म छह मान्यता प्राप्त संज्ञानात्मक स्क्रीनिंग उपकरणों का उपयोग करता है: MMSE (अभिविन्यास, स्मृति, ध्यान), MoCA (हल्की संज्ञानात्मक हानि का पता लगाना), ACE-III (व्यापक संज्ञानात्मक मूल्यांकन), Mini-Cog (संक्षिप्त स्क्रीनिंग), SLUMS (डिमेंशिया का पता लगाना), और RUDAS (सांस्कृतिक रूप से निष्पक्ष आकलन)।",
    benefits: "लाभ",
    benefit1: "समय के साथ भावनात्मक कल्याण रुझानों की निगरानी करें।",
    benefit2: "मानसिक स्वास्थ्य आकलन के लिए मानकीकृत स्क्रीनिंग स्कोर (PHQ-9, GAD-7, GHQ) ट्रैक करें।",
    benefit3: "संज्ञानात्मक हानि जोखिम पैटर्न और परिवर्तनों को दृश्य रूप से देखें।",
    benefit4: "पैटर्न की पहचान करें और बेहतर कल्याण के लिए डेटा-संचालित निर्णय लें।",
    benefit5: "दृश्य डेटा का उपयोग करके स्वास्थ्य देखभाल पेशेवरों के साथ प्रगति साझा करें।",
    usage: "कैसे उपयोग करें",
    usageDescription: "ऊपर दिए गए ड्रॉपडाउन मेनू का उपयोग करके चार्ट प्रकारों (बार/लाइन) और मेट्रिक श्रेणियों (भावनात्मक/स्क्रीनिंग/संज्ञानात्मक) के बीच स्विच करें। नवीनतम डेटा के साथ अपडेट करने के लिए 'रीफ्रेश' पर क्लिक करें। बार चार्ट व्यक्तिगत डेटा बिंदु दिखाते हैं, जबकि लाइन चार्ट समय के साथ रुझान प्रदर्शित करते हैं।",
    importantNotes: "महत्वपूर्ण नोट्स",
    note1: "ये मेट्रिक्स स्क्रीनिंग उपकरण हैं, निदान उपकरण नहीं। चिकित्सा सलाह के लिए हमेशा स्वास्थ्य देखभाल पेशेवरों से परामर्श करें।",
    note2: "स्कोर की व्याख्या पेशेवर मार्गदर्शन के साथ संदर्भ में की जानी चाहिए।",
    note3: "नियमित निगरानी (हर 3-6 महीने) परिवर्तनों और पैटर्न को ट्रैक करने में मदद करती है।",
    note4: "उच्च जोखिम स्कोर योग्य स्वास्थ्य देखभाल पेशेवरों के साथ परामर्श को प्रोत्साहित करना चाहिए।",
    languageNote: "भाषा समर्थन",
    languageDescription: "सभी चार्ट लेबल और विवरण स्वचालित रूप से आपकी चयनित भाषा के अनुकूल होते हैं ताकि एक सुसंगत उपयोगकर्ता अनुभव मिले।",
    insight: "अंतर्दृष्टि",
    insightDescription: "इन मेट्रिक्स का विश्लेषण पैटर्न की पहचान करने, तनाव का प्रबंधन करने और बेहतर कल्याण के लिए डेटा-संचालित निर्णय लेने में मदद कर सकता है।",
  },
  reminder: {
    title: "रिमाइंडर",
    message: "संदेश",
    when: "समय",
    customOption: "कस्टम दिनांक/समय चुनें",
    schedule: "रिमाइंडर सेट करें",
    scheduling: "रिमाइंडर सेट किया जा रहा है...",
    scheduled: "रिमाइंडर सफलतापूर्वक सेट हो गया!",
    cancelled: "रिमाइंडर रद्द कर दिया गया।",
    empty: "कोई रिमाइंडर नहीं।",
    invalidDate: "कृपया मान्य दिनांक और समय चुनें।",
    cancel: "रद्द करें",
    manage: "रिमाइंडर प्रबंधित करें",
    fetchError: "रिमाइंडर लाने में त्रुटि हुई।",
    scheduleError: "रिमाइंडर निर्धारित करने में असफल।",
    cancelError: "रिमाइंडर रद्द करने में असफल।",
    defaultMessage: "मैत्री की ओर से एक याद दिलाने वाला संदेश",
    presets: {
      "1day": "1 दिन में",
      "2day": "2 दिन में",
      "3day": "3 दिन में",
      "1week": "1 सप्ताह में"
    },
    quickAddPlaceholder: "त्वरित रिमाइंडर जोड़ें...",
    predefinedMessages: {
      takeMedicine: "दवा लें",
      doctorAppointment: "डॉक्टर की अपॉइंटमेंट",
      exercise: "व्यायाम",
      drinkWater: "पानी पिएं"
    },
    repeat: {
      none: "एक बार",
      daily: "दैनिक",
      weekly: "साप्ताहिक",
      monthly: "मासिक",
      custom: "कस्टम अंतराल"
    },
    addQuickReminder: "त्वरित रिमाइंडर जोड़ें",
    reminderMessagePlaceholder: "रिमाइंडर संदेश",
    emailPlaceholder: "आपका ईमेल",
    selectDateTime: "दिनांक और समय चुनें",
    time: "समय",
    optionalEndDate: "वैकल्पिक समाप्ति दिनांक",
    selected: "चयनित:",
    processing: "प्रसंस्करण...",
    addReminder: "रिमाइंडर जोड़ें",
    stats: "आंकड़े",
    totalReminders: "कुल रिमाइंडर",
    dailyReminders: "दैनिक रिमाइंडर",
    weeklyReminders: "साप्ताहिक रिमाइंडर",
    monthlyReminders: "मासिक रिमाइंडर",
    nextReminder: "अगला रिमाइंडर",
    allRepeats: "सभी दोहराव",
    byEmail: "ईमेल से",
    byMessage: "संदेश से",
    searchPlaceholder: "रिमाइंडर खोजें...",
    emailLabel: "ईमेल:",
    dateTimeLabel: "दिनांक और समय:",
    repeatLabel: "दोहराएं:",
    intervalLabel: "अंतराल:",
    endsLabel: "समाप्त:",
    statusLabel: "स्थिति:",
    delete: "हटाएं",
    loadingReminders: "रिमाइंडर लोड हो रहे हैं...",
    noReminders: "अभी तक कोई रिमाइंडर नहीं।",
    benefitsTitle: "डिमेंशिया रोगियों के लिए लाभ",
    benefitsText1: "नियमित रिमाइंडर डिमेंशिया रोगियों को दैनिक दिनचर्या बनाए रखने, भ्रम कम करने और स्मृति प्रतिधारण में सहायता करते हैं।",
    benefitsText2: "दवा, अपॉइंटमेंट और दैनिक गतिविधियों के लिए निर्धारित अलर्ट संरचना प्रदान करते हैं, स्वतंत्रता को बढ़ावा देते हैं और चिंता कम करते हैं।",
    allFieldsRequired: "सभी फ़ील्ड आवश्यक हैं।",
    validDateTimeRequired: "कृपया मान्य दिनांक और समय चुनें।",
    failedToAdd: "रिमाइंडर जोड़ने में असफल।",
    confirmDelete: "क्या आप वाकई इस रिमाइंडर को हटाना चाहते हैं?",
    failedToDelete: "रिमाइंडर हटाने में असफल।",
    quickAddRequired: "त्वरित जोड़ने के लिए संदेश और ईमेल आवश्यक हैं।",
    failedQuickAdd: "त्वरित रिमाइंडर जोड़ने में असफल।",
    none: "कोई नहीं"
  },
  dementia: {
    title: "डिमेंशिया चेकर",
    start: "शुरू करें",
    starting: "शुरू हो रहा है...",
    timeLeft: "शेष समय: {{seconds}} सेकंड",
    intro: "5–6 समय-सीमा वाले प्रश्न लाने के लिए 'शुरू करें' पर क्लिक करें। यदि समय समाप्त हो जाता है, तो खाली उत्तर स्वतः सहेजा जाएगा।",
    placeholder: "अपना उत्तर टाइप करें...",
    next: "अगला",
    submit: "जमा करें",
    progress: "प्रश्न {{current}} / {{total}}",
    draftTitle: "मसौदा उत्तर (स्थानीय)",
    emptyAnswer: "(खाली)",
    record: "रिकॉर्ड",
    stopRecording: "रिकॉर्डिंग रोकें",
    recording: "रिकॉर्डिंग...",
    preview: "पूर्वावलोकन",
    hasAudio: "ऑडियो सहित",
    questionHidden: "प्रश्न छुपा हुआ है। नीचे अपना उत्तर टाइप करें।",
    moderate: "मध्यम",
    category: "श्रेणी",
    failedToLoadQuestions: "प्रश्न लोड करने में विफल। कृपया पुनः प्रयास करें।",
    failedToStart: "परीक्षा शुरू करने में विफल। कृपया पुनः प्रयास करें।",
    microphonePermissionDenied: "माइक्रोफोन अनुमति अस्वीकृत। कृपया ऑडियो रिकॉर्ड करने के लिए माइक्रोफोन एक्सेस की अनुमति दें।",
    submissionError: "उत्तर जमा करने में विफल। कृपया पुनः प्रयास करें।",
    games: {
      clockTest: "घड़ी परीक्षण",
      colorSequence: "रंग अनुक्रम",
      matchingCards: "मिलान कार्ड",
      textRecall: "टेक्स्ट रिकॉल",
      reactionTime: "प्रतिक्रिया समय",
      numberOrder: "संख्या क्रम",
      wordMemory: "शब्द स्मृति",
      stroopTest: "स्ट्रूप टेस्ट",
      patternGrid: "पैटर्न ग्रिड",
      symbolMatch: "प्रतीक मिलान",
      oddColor: "विषम रंग",
      digitSpan: "अंक स्पैन",
      nBack: "एन-बैक",
      memory: "स्मृति मिलान",
      patternRecall: "पैटर्न रिकॉल",
      descriptions: {
        clockTest: "समय को सटीक रूप से पहचानें और सेट करें। समय जागरूकता और दृश्य-स्थानिक प्रसंस्करण का परीक्षण करता है।",
        colorSequence: "रंग अनुक्रम को याद रखें और क्रम में दोहराएं। कार्यशील स्मृति और अनुक्रमिक प्रसंस्करण का परीक्षण करता है।",
        matchingCards: "कार्ड की स्थिति याद करके जोड़े मिलाएं। दृश्य स्मृति और याद करने की क्षमता का मूल्यांकन करता है।",
        textRecall: "समय के दबाव में पाठ को पढ़ें और याद करें। मौखिक स्मृति और समझ का आकलन करता है।",
        reactionTime: "दृश्य उत्तेजनाओं पर तुरंत प्रतिक्रिया दें। प्रसंस्करण गति और ध्यान को मापता है।",
        numberOrder: "संख्या अनुक्रम को याद रखें और याद करें। अल्पकालिक स्मृति और संख्यात्मक प्रसंस्करण का परीक्षण करता है।",
        wordMemory: "शब्द सूचियों को याद करें और याद करें। मौखिक स्मृति और प्रतिधारण क्षमता का मूल्यांकन करता है।",
        stroopTest: "विरोधाभासी पाठ रंगों को नजरअंदाज करते हुए रंग नामों की पहचान करें। संज्ञानात्मक लचीलापन और निषेध का आकलन करता है।",
        patternGrid: "ग्रिड पर दृश्य पैटर्न को याद रखें और पुनर्निर्माण करें। स्थानिक स्मृति और दृश्य प्रसंस्करण का परीक्षण करता है।",
        symbolMatch: "प्रतीकों और पैटर्न को मिलाएं। पैटर्न पहचान और दृश्य-स्थानिक कौशल का मूल्यांकन करता है।",
        oddColor: "समान वस्तुओं में से अलग रंग की वस्तु की पहचान करें। विवरण पर ध्यान और दृश्य भेदभाव का परीक्षण करता है।",
        digitSpan: "अंकों के अनुक्रम को याद रखें और याद करें। कार्यशील स्मृति क्षमता और ध्यान का परीक्षण करता है।",
        nBack: "एक अनुक्रम में N चरण पीछे दिखाई देने वाली वस्तुओं की पहचान करें। कार्यशील स्मृति और कार्यकारी कार्य का परीक्षण करता है।",
        memory: "स्मृति से कार्ड के जोड़े मिलाएं। दृश्य स्मृति, पैटर्न पहचान और याद करने की क्षमता का मूल्यांकन करता है।",
        patternRecall: "रंग अनुक्रम को देखें और उसी क्रम में दोहराएं। कार्यशील स्मृति, अनुक्रमिक प्रसंस्करण और पैटर्न पहचान क्षमता का आकलन करता है।"
      },
      benefits: {
        clockTest: "समय जागरूकता और दृश्य-स्थानिक कौशल का आकलन करता है, जो अक्सर डिमेंशिया रोगियों में बिगड़ा हुआ है।",
        colorSequence: "स्मृति में गिरावट और कार्यकारी कार्य हानि के शुरुआती संकेतों का पता लगाने में मदद करता है।",
        matchingCards: "डिमेंशिया में आम दृश्य स्मृति की कमी और स्थानिक प्रसंस्करण समस्याओं की पहचान करता है।",
        textRecall: "मौखिक स्मृति की समस्याएं और भाषा समझ की कठिनाइयों को प्रकट करता है।",
        reactionTime: "धीमी संज्ञानात्मक प्रसंस्करण का पता लगाता है, जो संज्ञानात्मक गिरावट का प्रारंभिक संकेतक है।",
        numberOrder: "कार्यशील स्मृति क्षमता का आकलन करता है, जो अक्सर डिमेंशिया के शुरुआती चरणों में प्रभावित होती है।",
        wordMemory: "मौखिक स्मृति प्रतिधारण का मूल्यांकन करता है, जो स्मृति-संबंधी संज्ञानात्मक समस्याओं का पता लगाने के लिए महत्वपूर्ण है।",
        stroopTest: "कार्यकारी कार्य और संज्ञानात्मक नियंत्रण को मापता है, जो डिमेंशिया रोगियों में बिगड़ा हुआ है।",
        patternGrid: "स्थानिक स्मृति और दृश्य प्रसंस्करण का परीक्षण करता है, जो डिमेंशिया से अक्सर प्रभावित होते हैं।",
        symbolMatch: "पैटर्न पहचान क्षमताओं का आकलन करता है, जो संज्ञानात्मक हानि के साथ कम हो जाती है।",
        oddColor: "ध्यान और दृश्य भेदभाव का मूल्यांकन करता है, कौशल जो डिमेंशिया में बिगड़ते हैं।",
        digitSpan: "कार्यशील स्मृति स्पैन को मापता है, जो संज्ञानात्मक स्वास्थ्य और प्रारंभिक डिमेंशिया संकेतों का एक प्रमुख संकेतक है।",
        nBack: "कार्यशील स्मृति और कार्यकारी नियंत्रण का मूल्यांकन करता है, जो संज्ञानात्मक गिरावट से प्रभावित महत्वपूर्ण कार्य हैं।",
        memory: "दृश्य स्मृति और पैटर्न पहचान का परीक्षण करता है, आवश्यक कौशल जो डिमेंशिया प्रगति के साथ बिगड़ते हैं।",
        patternRecall: "अनुक्रमिक स्मृति और कार्यशील स्मृति क्षमता का मूल्यांकन करता है, महत्वपूर्ण संज्ञानात्मक कार्य जो प्रारंभिक-चरण डिमेंशिया में कम हो जाते हैं। स्मृति एन्कोडिंग और पुनर्प्राप्ति घाटे की पहचान करने में मदद करता है।"
      }
    },
    completed: "पूर्ण",
    play: "खेलें",
    completedCount: "पूर्ण {{count}} / 5",
    calculating: "गणना कर रहा है...",
    viewResults: "परिणाम देखें",
    reset: "रीसेट",
    riskAssessmentResults: "जोखिम मूल्यांकन परिणाम",
    calculatingAssessment: "आपका जोखिम मूल्यांकन गणना कर रहा है...",
    riskScore: "जोखिम स्कोर",
    riskLevel: "जोखिम स्तर",
    averageScore: "औसत स्कोर",
    averageTime: "औसत समय",
    explanation: "स्पष्टीकरण",
    suggestions: "सुझाव",
    gameResultsSummary: "खेल परिणाम सारांश",
    failedAssessment: "जोखिम मूल्यांकन की गणना करने में विफल। कृपया पुनः प्रयास करें।",
    score: "स्कोर",
    time: "समय",
    howItHelps: "यह कैसे मदद करता है:",
    testCompleted: "परीक्षा पूर्ण!",
    saveContinue: "सहेजें और जारी रखें",
    close: "बंद करें",
    exit: "बाहर निकलें",
    backToGames: "खेलों पर वापस जाएं",
    points: "अंक",
    totalTime: "कुल समय",
    rounds: "राउंड",
    attempts: "प्रयास",
    accuracy: "सटीकता",
    errors: "गलतियाँ",
    round: "राउंड",
    selectDifficulty: "कठिनाई चुनें:",
    easy: "आसान",
    medium: "मध्यम",
    hard: "कठिन",
    submit: "जमा करें",
    submitAnswer: "उत्तर जमा करें",
    next: "अगला",
    timer: "टाइमर",
    digits: "अंक",
    performance: {
      excellent: "उत्कृष्ट प्रदर्शन!",
      good: "अच्छा प्रदर्शन!",
      fair: "ठीक प्रदर्शन!",
      practice: "अभ्यास जारी रखें!"
    },
    performanceDesc: {
      excellent: "उत्कृष्ट संज्ञानात्मक प्रदर्शन! बेहतरीन काम जारी रखें।",
      good: "ठोस प्रदर्शन! आप अपने संज्ञानात्मक अभ्यासों के साथ अच्छा कर रहे हैं।",
      fair: "अच्छा प्रयास! नियमित अभ्यास आपके स्कोर में सुधार करने में मदद करेगा।",
      practice: "हार मत मानो! सुधार देखने के लिए नियमित रूप से अभ्यास करें।"
    },
    confirmReset: "क्या आप वाकई सभी प्रगति रीसेट करना चाहते हैं?",
    needMoreGames: "कृपया परिणाम देखने के लिए कम से कम {{count}} खेल पूरे करें।",
    gamesRemaining: "{{count}} और",
    gamesRemainingText: "खेल की आवश्यकता है",
    emailSent: "रिपोर्ट आपके ईमेल पर सफलतापूर्वक भेजी गई!",
    emailFailed: "ईमेल भेजा नहीं जा सका, लेकिन आपकी रिपोर्ट नीचे उपलब्ध है।",
    networkError: "नेटवर्क कनेक्शन त्रुटि। कृपया अपना इंटरनेट कनेक्शन जांचें और पुनः प्रयास करें।",
    domainMemory: "स्मृति",
    domainLanguage: "भाषा",
    domainAttention: "ध्यान",
    domainOrientation: "अभिविन्यास",
    domainExecutive: "कार्यकारी",
    cognitiveDomains: "संज्ञानात्मक डोमेन स्कोर",
    weightedRiskScore: "भारित जोखिम स्कोर",
    howScoringWorks: "परिणाम कैसे स्कोर और मूल्यांकन किए जाते हैं",
    gameBasedScoring: "गेम-आधारित आकलन स्कोरिंग",
    cognitiveScoringExplanation: "संज्ञानात्मक मेट्रिक्स विभिन्न संज्ञानात्मक गेमों में आपके प्रदर्शन से गणना की जाती है। प्रत्येक गेम मान्यता प्राप्त न्यूरोसाइकोलॉजिकल परीक्षण प्रतिमानों के आधार पर विशिष्ट संज्ञानात्मक डोमेन का आकलन करने के लिए डिज़ाइन किया गया है। प्रत्येक गेम से आपके कच्चे स्कोर को निष्पक्ष तुलना सुनिश्चित करने के लिए कठिनाई स्तर (आसान, मध्यम, कठिन) द्वारा सामान्यीकृत किया जाता है। उपयोग किया गया सूत्र है: सामान्यीकृत स्कोर = (कच्चा स्कोर / कठिनाई के लिए अधिकतम संभव स्कोर) × 100। यह सामान्यीकरण विभिन्न कठिनाई गुणकों (आसान: 1.0x, मध्यम: 1.5x, कठिन: 2.0x) को ध्यान में रखता है और सुनिश्चित करता है कि स्कोर गेम और कठिनाई स्तरों में तुलनीय हैं।",
    domainMapping: "गेम-से-डोमेन मैपिंग",
    domainMappingExplanation: "प्रत्येक गेम नैदानिक औचित्य के साथ विशिष्ट संज्ञानात्मक डोमेन से मैप करता है: डिजिट स्पैन और N-Back मुख्य रूप से मेमोरी (कार्यशील मेमोरी क्षमता) का परीक्षण करते हैं। पैटर्न रिकॉल और मेमोरी मैच मेमोरी और ध्यान का आकलन करते हैं। रिएक्शन टाइम ध्यान और प्रसंस्करण गति को मापता है। स्ट्रूप टेस्ट कार्यकारी कार्य (संज्ञानात्मक लचीलापन और निषेध) का मूल्यांकन करता है। क्लॉक ड्राइंग कार्यकारी कार्य, अभिविन्यास, और दृश्य-स्थानिक क्षमताओं का परीक्षण करता है। टेक्स्ट रिकॉल (डिमेंशिया चेकर) मेमोरी और भाषा का आकलन करता है। प्रत्येक गेम भारित महत्व के साथ डोमेन स्कोर में योगदान देता है जो इस बात पर आधारित है कि यह मुख्य रूप से किस संज्ञानात्मक कार्य का परीक्षण करता है।",
    weightedRiskCalculation: "भारित जोखिम स्कोर गणना",
    weightedRiskExplanation: "अंतिम संज्ञानात्मक जोखिम स्कोर नैदानिक अनुसंधान पर आधारित भारित डोमेन मॉडल का उपयोग करता है: मेमोरी (30% भार) - मुख्य प्रारंभिक डिमेंशिया मार्कर, भाषा (20%) - शब्द-खोज समस्याएं जल्दी दिखाई देती हैं, ध्यान (20%) - कार्यकारी गिरावट ध्यान को प्रभावित करती है, अभिविन्यास (15%) - मध्यम प्रभाव, कार्यकारी कार्य (15%) - महत्वपूर्ण लेकिन आमतौर पर देर से चरण मार्कर। सूत्र गणना करता है: भारित जोखिम स्कोर = Σ(डोमेन जोखिम × डोमेन भार), जहां डोमेन जोखिम = 1 - (डोमेन स्कोर / 10)। उच्च डोमेन स्कोर (0-10 पैमाने) बेहतर संज्ञानात्मक कार्य को दर्शाते हैं, जिसके परिणामस्वरूप कम जोखिम स्कोर (0-1 पैमाने) होते हैं। जोखिम स्तर निर्धारित किए जाते हैं: उच्च (≥70%), मध्यम (40-69%), कम (<40%)।",
    whatEachGameTests: "प्रत्येक गेम क्या परीक्षण करता है",
    digitSpanGame: "डिजिट स्पैन",
    digitSpanGameDesc: "आपको अंकों के अनुक्रमों को याद रखने और याद करने की आवश्यकता के द्वारा कार्यशील मेमोरी क्षमता का परीक्षण करता है। तत्काल मेमोरी स्पैन को मापता है, जो संज्ञानात्मक स्वास्थ्य का एक प्रमुख संकेतक है। प्रारंभिक अल्जाइमर रोग अल्पकालिक याद को प्रभावित करता है, जिससे यह परीक्षण प्रारंभिक संज्ञानात्मक गिरावट के प्रति संवेदनशील हो जाता है।",
    nBackGame: "N-Back",
    nBackGameDesc: "आपको एक अनुक्रम में N कदम पीछे दिखाई देने वाली वस्तुओं की पहचान करने की आवश्यकता के द्वारा कार्यशील मेमोरी और कार्यकारी कार्य का मूल्यांकन करता है। कार्यशील मेमोरी में जानकारी को बनाए रखने और अपडेट करने की आपकी क्षमता का परीक्षण करता है, जो हल्के संज्ञानात्मक हानि (MCI) गिरावट के प्रति संवेदनशील है।",
    patternRecallGame: "पैटर्न रिकॉल",
    patternRecallGameDesc: "आपको दृश्य पैटर्न को याद रखने और पुन: उत्पादन करने की आवश्यकता के द्वारा दृश्य मेमोरी और अनुक्रमिक प्रसंस्करण का परीक्षण करता है। मेमोरी एन्कोडिंग और पुनर्प्राप्ति घाटे का मूल्यांकन करता है, जो महत्वपूर्ण संज्ञानात्मक कार्य हैं जो प्रारंभिक-चरण डिमेंशिया में गिरते हैं।",
    memoryMatchGame: "मेमोरी मैच",
    memoryMatchGameDesc: "आपको उनकी स्थिति याद रखकर कार्डों के जोड़े मिलाने की आवश्यकता के द्वारा साहचर्य मेमोरी का आकलन करता है। हिप्पोकैम्पल-निर्भर मेमोरी सिस्टम का परीक्षण करता है, जो प्रारंभिक अल्जाइमर रोग में दृढ़ता से प्रभावित होते हैं। दृश्य मेमोरी घाटे और स्थानिक प्रसंस्करण समस्याओं की पहचान करता है।",
    reactionTimeGame: "रिएक्शन टाइम",
    reactionTimeGameDesc: "दृश्य उत्तेजनाओं के लिए त्वरित प्रतिक्रियाओं की आवश्यकता के द्वारा प्रसंस्करण गति और ध्यान को मापता है। धीमी संज्ञानात्मक प्रसंस्करण का पता लगाता है, जो संज्ञानात्मक गिरावट का एक प्रारंभिक संकेतक है। औसत प्रतिक्रिया समय, परिवर्तनशीलता, और सबसे धीमी 10% प्रतिक्रियाओं को ट्रैक करता है।",
    colorSequenceGame: "रंग अनुक्रम",
    colorSequenceGameDesc: "आपको क्रम में रंग अनुक्रमों को याद रखने और दोहराने की आवश्यकता के द्वारा अनुक्रमिक मेमोरी का परीक्षण करता है। कार्यशील मेमोरी और कार्यकारी कार्य घटकों का मूल्यांकन करता है जो प्रारंभिक डिमेंशिया में प्रभावित होते हैं। मेमोरी में अनुक्रमों को बनाए रखने की क्षमता को मापता है।",
    stroopTestGame: "स्ट्रूप टेस्ट",
    stroopTestGameDesc: "आपको विरोधाभासी पाठ रंगों को नजरअंदाज करते हुए रंग नामों की पहचान करने की आवश्यकता के द्वारा संज्ञानात्मक लचीलापन और निषेध का आकलन करता है। कार्यकारी कार्य और संज्ञानात्मक नियंत्रण को मापता है, जो डिमेंशिया रोगियों में बिगड़ा हुआ है। स्वचालित प्रतिक्रियाओं को रोकने की क्षमता का परीक्षण करता है।",
    clockDrawingGame: "क्लॉक ड्राइंग",
    clockDrawingGameDesc: "डिमेंशिया के लिए व्यापक रूप से उपयोग किया जाने वाला स्क्रीनिंग उपकरण जो दृश्य-स्थानिक कौशल, कार्यकारी कार्य, ध्यान, और शब्दार्थ मेमोरी सहित कई संज्ञानात्मक डोमेन का आकलन करता है। यह एक नैदानिक रूप से मान्यता प्राप्त परीक्षण (CDT) है जिसका उपयोग MMSE, MoCA, और अन्य आकलनों में किया जाता है। क्लॉक ड्राइंग में हानि संज्ञानात्मक गिरावट के मजबूत संकेतक हैं।",
    textRecallGame: "टेक्स्ट रिकॉल",
    textRecallGameDesc: "आपको पाठ अंशों को पढ़ने और याद करने की आवश्यकता के द्वारा मेमोरी और भाषा का मूल्यांकन करता है। मौखिक मेमोरी, भाषा समझ, और प्रतिधारण क्षमता का परीक्षण करता है। प्रारंभिक अल्जाइमर की विशेषता में मेमोरी और भाषा घाटे शामिल हैं, जिससे यह परीक्षण प्रारंभिक पहचान के लिए अत्यधिक प्रासंगिक हो जाता है।",
    primaryDomain: "प्राथमिक डोमेन",
    secondaryDomain: "द्वितीयक",
    importantDisclaimer: "महत्वपूर्ण अस्वीकरण",
    disclaimerTitle: "आकलन उद्देश्य",
    disclaimerText1: "ये संज्ञानात्मक आकलन केवल स्क्रीनिंग और आत्म-मूल्यांकन उद्देश्यों के लिए डिज़ाइन किए गए हैं। वे मान्यता प्राप्त न्यूरोसाइकोलॉजिकल परीक्षण प्रतिमानों पर आधारित हैं लेकिन पेशेवर चिकित्सा मूल्यांकन, निदान, या उपचार को प्रतिस्थापित करने के लिए अभिप्रेत नहीं हैं।",
    disclaimerTitle2: "नैदानिक व्याख्या",
    disclaimerText2: "परिणामों की व्याख्या योग्य स्वास्थ्य देखभाल पेशेवरों द्वारा व्यापक नैदानिक आकलन, चिकित्सा इतिहास, और उपयुक्त नैदानिक परीक्षण के साथ मिलकर की जानी चाहिए। स्कोर थकान, तनाव, दवा प्रभाव, या अस्थायी स्वास्थ्य स्थितियों जैसे कारकों से प्रभावित हो सकते हैं।",
    disclaimerTitle3: "निदान नहीं",
    disclaimerText3: "प्लेटफ़ॉर्म चिकित्सा निदान, उपचार सिफारिशें, या नैदानिक निर्णय-निर्माण सहायता प्रदान नहीं करता है। किसी भी चिकित्सा चिंताओं या स्वास्थ्य-संबंधी निर्णय लेने से पहले हमेशा लाइसेंस प्राप्त स्वास्थ्य देखभाल पेशेवरों से परामर्श करें।",
    assessmentMethodology: "आकलन पद्धति",
    methodologyText: "स्कोर भारित संज्ञानात्मक डोमेन मॉडल का उपयोग करके गणना की जाती है। गेम नैदानिक औचित्य के साथ विशिष्ट संज्ञानात्मक डोमेन (मेमोरी, भाषा, ध्यान, अभिविन्यास, कार्यकारी) से मैप करते हैं। निष्पक्ष तुलना के लिए कठिनाई स्तर द्वारा स्कोर सामान्यीकृत किए जाते हैं।",
    gameError: "खेल लोड करते समय एक त्रुटि हुई।",
    errorMessage: "कुछ गलत हुआ। कृपया पृष्ठ को रीफ्रेश करें।",
    loadingGames: "खेल लोड हो रहे हैं...",
    errorLoadingGames: "खेल लोड करने में त्रुटि",
    refreshPage: "पृष्ठ रीफ्रेश करें",
    gamesCompleted: "खेल पूर्ण",
    game: "खेल",
    ageGroup: "आयु समूह",
    subtitle: "वैज्ञानिक रूप से डिज़ाइन किए गए संज्ञानात्मक मूल्यांकन के साथ जुड़ें जो मेमोरी, ध्यान, भाषा और कार्यकारी कौशल सहित प्रमुख मानसिक कार्यों का मूल्यांकन करते हैं। व्यापक AI-संचालित जोखिम मूल्यांकन और आपके संज्ञानात्मक स्वास्थ्य में व्यक्तिगत अंतर्दृष्टि प्राप्त करने के लिए कई खेल पूरे करें।",
    importantDisclaimer: "महत्वपूर्ण अस्वीकरण",
    assessmentPurpose: "मूल्यांकन उद्देश्य",
    assessmentPurposeText: "ये संज्ञानात्मक मूल्यांकन केवल स्क्रीनिंग और आत्म-मूल्यांकन उद्देश्यों के लिए डिज़ाइन किए गए हैं। वे मान्य न्यूरोसाइकोलॉजिकल परीक्षण प्रतिमानों पर आधारित हैं लेकिन पेशेवर चिकित्सा मूल्यांकन, निदान, या उपचार को प्रतिस्थापित करने के लिए अभिप्रेत नहीं हैं।",
    clinicalInterpretation: "नैदानिक व्याख्या",
    clinicalInterpretationText: "परिणामों की व्याख्या योग्य स्वास्थ्य सेवा पेशेवरों द्वारा व्यापक नैदानिक मूल्यांकन, चिकित्सा इतिहास, और उपयुक्त नैदानिक परीक्षण के साथ मिलकर की जानी चाहिए।",
    notADiagnosis: "निदान नहीं",
    notADiagnosisText: "प्लेटफ़ॉर्म चिकित्सा निदान, उपचार सिफारिशें, या नैदानिक निर्णय-निर्माण सहायता प्रदान नहीं करता है। किसी भी चिकित्सा चिंताओं के लिए हमेशा लाइसेंस प्राप्त स्वास्थ्य देखभाल पेशेवरों से परामर्श करें।",
    howScoringWorks: "परिणाम कैसे स्कोर और मूल्यांकन किए जाते हैं",
    gameBasedScoring: "गेम-आधारित आकलन स्कोरिंग",
    gameBasedScoringText: "संज्ञानात्मक मेट्रिक्स विभिन्न संज्ञानात्मक खेलों में आपके प्रदर्शन से गणना की जाती है। प्रत्येक खेल मान्य न्यूरोसाइकोलॉजिकल परीक्षण प्रतिमानों के आधार पर विशिष्ट संज्ञानात्मक डोमेन का मूल्यांकन करने के लिए डिज़ाइन किया गया है।",
    weightedRiskScore: "भारित जोखिम स्कोर गणना",
    weightedRiskScoreText: "अंतिम संज्ञानात्मक जोखिम स्कोर एक भारित डोमेन मॉडल का उपयोग करता है: मेमोरी (30%), भाषा (20%), ध्यान (20%), अभिविन्यास (15%), कार्यकारी कार्य (15%)।",
    whatEachGameTests: "प्रत्येक खेल क्या परीक्षण करता है",
    domainMemory: "मेमोरी",
    domainAttention: "ध्यान",
    domainExecutive: "कार्यकारी",
    domainOrientation: "अभिविन्यास",
    domainLanguage: "भाषा",
    gameInfo: {
      colorSequence: "दृश्य कार्यशील स्मृति और पैटर्न पहचान का परीक्षण करता है",
      digitSpan: "कार्यशील स्मृति क्षमता का परीक्षण करता है",
      memory: "साहचर्य स्मृति का मूल्यांकन करता है",
      nBack: "कार्यशील स्मृति और ध्यान का मूल्यांकन करता है",
      reactionTime: "प्रसंस्करण गति और ध्यान को मापता है",
      stroopTest: "संज्ञानात्मक लचीलापन का मूल्यांकन करता है",
      patternRecall: "दृश्य स्मृति और पैटर्न पहचान का परीक्षण करता है",
      clockDrawing: "कई संज्ञानात्मक डोमेन का परीक्षण करता है"
    },
    assessmentSummary: "मूल्यांकन सारांश",
    recommendations: "सुझाव",
    gameResults: "खेल परिणाम",
    disclaimer: "महत्वपूर्ण अस्वीकरण",
    disclaimerText: "यह मूल्यांकन केवल आत्म-मूल्यांकन उद्देश्यों के लिए AI-जनित है। इसे नैदानिक निदान नहीं माना जाना चाहिए। किसी भी चिकित्सा मूल्यांकन या चिंताओं के लिए कृपया एक लाइसेंस प्राप्त स्वास्थ्य देखभाल पेशेवर से परामर्श करें।",
    sendingEmail: "आपके ईमेल पर रिपोर्ट भेजी जा रही है...",
    icons: {
      colorSequence: "🎨",
      textRecall: "📝",
      digitSpan: "🔢",
      memory: "🧩",
      nBack: "🔄",
      reactionTime: "⚡",
      stroopTest: "🎯",
      patternRecall: "🔁"
    },
    colorSequence: {
      memorizeSequence: "इस अनुक्रम को याद रखें:",
      clickColorsOrder: "रंगों को उसी क्रम में क्लिक करें!",
      yourSequence: "आपका अनुक्रम:"
    },
    patternRecall: {
      description: "रंग अनुक्रम दोहराकर अपनी स्मृति का परीक्षण करें। पैटर्न देखें और फिर उसी क्रम में रंगों पर क्लिक करें।",
      easyInfo: "3 रंग, 4 राउंड",
      mediumInfo: "4 रंग, 6 राउंड",
      hardInfo: "5 रंग, 8 राउंड",
      watchSequence: "अनुक्रम को ध्यान से देखें...",
      repeatSequence: "अब क्रम में रंगों पर क्लिक करके अनुक्रम को दोहराएं!",
      yourSequence: "आपका अनुक्रम:",
      correct: "सही! बहुत बढ़िया!",
      incorrect: "गलत अनुक्रम। अगले राउंड में जा रहे हैं...",
      red: "लाल",
      green: "हरा",
      blue: "नीला",
      yellow: "पीला",
      purple: "बैंगनी",
      orange: "नारंगी"
    },
    stroopInstruction: "शब्द के रंग पर क्लिक करें, पाठ पर नहीं!",
    stroopHint: "यह शब्द किस रंग का है?",
    symbolMatchDescription: "प्रतीकों के जोड़े मिलाकर अपनी दृश्य स्मृति और पैटर्न पहचान का परीक्षण करें। यह मूल्यांकन आपकी कार्यशील स्मृति और विवरण पर ध्यान का मूल्यांकन करता है।",
    loading: "खेल लोड हो रहा है..."
  },
  login: {
    googleLogin: "Google से जारी रखें",
    loading: "लोड हो रहा है, कृपया प्रतीक्षा करें..."
  },
  talk: {
    title: "स्वास्थ्य सेवा पेशेवरों से जुड़ें",
    subtitle: "थेरैपिस्ट और स्वास्थ्य सेवा प्रदाताओं के हमारे सत्यापित नेटवर्क के साथ अपॉइंटमेंट बुक करें।",
    loading: "पेशेवर लोड हो रहे हैं...",
    loadingHealthcare: "स्वास्थ्य सेवा पेशेवर लोड हो रहे हैं...",
    loadingTherapists: "थेरैपिस्ट लोड हो रहे हैं...",
    noCounselors: "अभी कोई पेशेवर उपलब्ध नहीं है।",
    noHealthcare: "अभी कोई स्वास्थ्य सेवा पेशेवर उपलब्ध नहीं है।",
    noTherapists: "अभी कोई थेरैपिस्ट उपलब्ध नहीं है।",
    noMatchingCounselors: "आपकी खोज मानदंडों से मेल खाने वाला कोई पेशेवर नहीं है।",
    noMatchingHealthcare: "आपकी खोज मानदंडों से मेल खाने वाला कोई स्वास्थ्य सेवा पेशेवर नहीं है।",
    noMatchingTherapists: "आपकी खोज मानदंडों से मेल खाने वाला कोई थेरैपिस्ट नहीं है।",
    counselors: "पेशेवर",
    healthcareProfessionalsTab: "स्वास्थ्य सेवा पेशेवर",
    therapistsTab: "थेरैपिस्ट",
    bookAppointment: "अपॉइंटमेंट बुक करें",
    selectDate: "दिनांक चुनें",
    selectTime: "समय स्लॉट चुनें",
    patientNotes: "रोगी नोट्स (वैकल्पिक)",
    confirmBooking: "बुकिंग की पुष्टि करें",
    bookingLoading: "बुकिंग हो रही है...",
    bookingSuccess: "अपॉइंटमेंट सफलतापूर्वक बुक किया गया!",
    bookingError: "अपॉइंटमेंट बुक करने में विफल। कृपया पुनः प्रयास करें।",
    errorFetching: "पेशेवरों को लाने में त्रुटि",
    showingResults: "दिखा रहा है",
    of: "का",
    notProvided: "N/A",
    error: "त्रुटि",
    search: "खोजें",
    filterBy: "फ़िल्टर करें",
    refresh: "रीफ़्रेश करें",
    email: "ईमेल",
    phone: "फोन",
    specialization: "विशेषता",
    experience: "अनुभव",
    years: "वर्ष",
    yearsFull: "वर्ष",
    qualifications: "योग्यताएँ",
    callNow: "अब कॉल करें",
    footer: "मानसिक स्वास्थ्य को सशक्त बनाना",
    therapistForm: "थेरपिस्ट फॉर्म",
    adminDashboard: "एडमिन डैशबोर्ड",
    selectDateAndTime: "कृपया दिनांक और समय स्लॉट चुनें",
    noAvailabilitySet: "अभी तक कोई उपलब्धता सेट नहीं की गई है",
    view: "देखें",
    book: "बुक करें",
    availableSlots: "उपलब्ध स्लॉट",
    healthcareProfessionalProfile: "स्वास्थ्य सेवा पेशेवर प्रोफ़ाइल",
    therapistProfile: "थेरैपिस्ट प्रोफ़ाइल",
    about: "के बारे में",
    mins: "मिनट",
    qualification: "योग्यता",
    license: "लाइसेंस",
    specializations: "विशेषज्ञताएं",
    therapyApproaches: "थेरेपी दृष्टिकोण",
    languages: "भाषाएं",
    communicationMode: "संचार मोड",
    comfortableWith: "सहज",
    doesNotHandle: "संभालता नहीं",
    ageGroupsServed: "सेवित आयु समूह",
    availability: "उपलब्धता",
    dateSlotsAvailable: "दिनांक स्लॉट उपलब्ध",
    close: "बंद करें",
    availableDates: "उपलब्ध दिनांक",
    slots: "स्लॉट",
    noAvailableDates: "इस समय कोई उपलब्ध दिनांक नहीं",
    noSlotsAvailable: "इस दिनांक के लिए कोई समय स्लॉट उपलब्ध नहीं",
    notes: "नोट्स",
    optional: "वैकल्पिक",
    notesPlaceholder: "कोई अतिरिक्त जानकारी...",
    characters: "वर्ण",
    cancel: "रद्द करें",
    booking: "बुकिंग हो रही है...",
    confirmAppointment: "अपॉइंटमेंट की पुष्टि करें",
    success: "सफलता",
    allSpecializations: "सभी विशेषज्ञताएं",
    searchPlaceholder: "नाम या विशेषज्ञता से खोजें...",
    clearFilters: "फ़िल्टर साफ़ करें"
  },
  aboutMaitri: {
    heroTitle: "मैत्री के बारे में",
    heroSubtitle: "डिमेंशिया मूल्यांकन और संज्ञानात्मक स्वास्थ्य निगरानी के लिए एक व्यापक डिजिटल प्लेटफॉर्म",
    heroDescription: "मैत्री प्रमाण-आधारित संज्ञानात्मक मूल्यांकन और AI-संचालित एनालिटिक्स का उपयोग करके डिमेंशिया और संज्ञानात्मक गिरावट के लिए प्रारंभिक पहचान, जोखिम मूल्यांकन और निगरानी उपकरण प्रदान करता है। हमारा प्लेटफॉर्म वैज्ञानिक कठोरता को सुलभ प्रौद्योगिकी के साथ जोड़ता है ताकि व्यक्तियों, परिवारों और स्वास्थ्य सेवा पेशेवरों का समर्थन किया जा सके।",
    dementiaOverviewTitle: "डिमेंशिया को समझना: एक वैज्ञानिक अवलोकन",
    dementiaDefinitionTitle: "डिमेंशिया क्या है?",
    dementiaDefinitionParagraph1: "डिमेंशिया एक नैदानिक सिंड्रोम है जो प्रगतिशील संज्ञानात्मक गिरावट की विशेषता है जो दैनिक कार्यप्रणाली में हस्तक्षेप करता है। इसमें न्यूरोडीजेनेरेटिव विकारों की एक श्रृंखला शामिल है, सबसे अधिक अल्जाइमर रोग (AD), संवहनी डिमेंशिया, लेवी बॉडी डिमेंशिया, और फ्रंटोटेम्पोरल डिमेंशिया। यह स्थिति स्मृति, कार्यकारी कार्य, भाषा, दृश्य-स्थानिक क्षमताओं और व्यवहारिक विनियमन को प्रभावित करती है।",
    dementiaDefinitionParagraph2: "डिमेंशिया एक एकल बीमारी नहीं है बल्कि एक शब्द है जो लक्षणों के एक समूह का वर्णन करता है जो स्मृति, सोच और सामाजिक क्षमताओं को इतनी गंभीरता से प्रभावित करता है कि दैनिक जीवन में हस्तक्षेप होता है। जबकि स्मृति हानि एक सामान्य लक्षण है, डिमेंशिया में केवल भूलने की बीमारी से कहीं अधिक शामिल है। यह किसी व्यक्ति की संचार, तर्क और रोजमर्रा के कार्य करने की क्षमता को प्रभावित कर सकता है।",
    dementiaDefinitionParagraph3: "प्रारंभिक संकेतों में हाल की घटनाओं को याद रखने में कठिनाई, भाषा की समस्याएं, भटकाव, मूड में बदलाव और प्रेरणा की हानि शामिल हो सकती है। जैसे-जैसे स्थिति बढ़ती है, व्यक्तियों को बढ़ते स्तर की देखभाल और समर्थन की आवश्यकता हो सकती है। मैत्री द्वारा प्रदान किए गए संज्ञानात्मक मूल्यांकन उपकरणों के माध्यम से प्रारंभिक पहचान संभावित समस्याओं की पहचान करने और समय पर हस्तक्षेप को सक्षम करने में मदद कर सकती है।",
    dementiaStatsTitle: "वैश्विक प्रभाव",
    dementiaStatsList: [
      "दुनिया भर में 55 मिलियन से अधिक लोग डिमेंशिया के साथ रहते हैं",
      "हर साल लगभग 10 मिलियन नए मामले",
      "डिमेंशिया दुनिया भर में मृत्यु का 7वां प्रमुख कारण है",
      "वैश्विक लागत प्रति वर्ष $1.3 ट्रिलियन से अधिक है",
      "2050 तक, मामलों की संख्या 152 मिलियन तक पहुंचने की उम्मीद है",
      "दो-तिहाई मामले निम्न और मध्यम आय वाले देशों में होते हैं"
    ],
    dementiaTypesTitle: "डिमेंशिया के प्रमुख प्रकार",
    missionTitle: "हमारा मिशन",
    missionDescription: "सुलभ, प्रमाण-आधारित संज्ञानात्मक मूल्यांकन उपकरण प्रदान करना जो डिमेंशिया जोखिम की प्रारंभिक पहचान को सक्षम करते हैं, नैदानिक निर्णय लेने का समर्थन करते हैं, और व्यक्तियों और परिवारों को संज्ञानात्मक स्वास्थ्य प्रबंधन में सक्रिय कदम उठाने के लिए सशक्त बनाते हैं।",
    visionTitle: "हमारा विज़न",
    visionDescription: "एक ऐसी दुनिया जहाँ डिमेंशिया के लिए प्रारंभिक पहचान और हस्तक्षेप सभी के लिए सुलभ हो, प्रौद्योगिकी-सक्षम मूल्यांकन, निगरानी और समर्थन के माध्यम से संज्ञानात्मक गिरावट के वैश्विक बोझ को कम करना।",
    assessmentTitle: "संज्ञानात्मक मूल्यांकन ढांचा",
    assessmentIntro: "हमारा प्लेटफॉर्म स्थापित न्यूरोसाइकोलॉजिकल परीक्षण प्रतिमानों पर आधारित मान्य संज्ञानात्मक मूल्यांकन उपकरणों का उपयोग करता है। प्रत्येक मूल्यांकन विशिष्ट संज्ञानात्मक डोमेन का मूल्यांकन करने के लिए डिज़ाइन किया गया है:",
    featuresTitle: "प्लेटफॉर्म सुविधाएं",
    featuresTitle: "हम क्या प्रदान करते हैं",
    features: [
      "मार्गदर्शित जर्नलिंग जिससे आप अपनी भावनाओं पर विचार कर सकें और प्रगति का ट्रैक रख सकें।",
      "वास्तविक समय सहायता और मार्गदर्शन के लिए इंटरैक्टिव चैटबॉट।",
      "व्यक्तिगत भावनात्मक अंतर्दृष्टि और स्क्रीनिंग उपकरण।",
      "कल्याण पर शैक्षिक लेख, वीडियो और संसाधन।",
      "विशेषज्ञ सलाह और साथियों के प्रोत्साहन के साथ एक सहायक सामुदायिक स्थान।",
      "हर किसी के लिए सुलभ और कलंक-मुक्त उपकरण।"
    ],
    videosTitle: "उपयोगी वीडियो",
    tipsTitle: "मानसिक स्वास्थ्य सुझाव",
    tips: [
      "प्रतिदिन उन चीज़ों को लिखें जिनके लिए आप आभारी हैं।",
      "नियमित व्यायाम करें ताकि मूड बेहतर हो और तनाव कम हो।",
      "मित्रों और परिवार से जुड़े रहें।",
      "बड़े लक्ष्यों को छोटे-छोटे चरणों में बाँटें।",
      "डिजिटल डिटॉक्स लें और सोशल मीडिया से ब्रेक लें।",
      "प्रतिदिन ध्यान, मेडिटेशन या गहरी साँसों का अभ्यास करें।",
      "जब ज़रूरत हो तो पेशेवर मदद लें—समर्थन माँगना एक ताक़त है।"
    ],
    faqsTitle: "अक्सर पूछे जाने वाले प्रश्न",
    faq1: {
      question: "मैत्री क्या है?",
      answer: "मैत्री एक डिजिटल प्लेटफ़ॉर्म है जो जर्नलिंग, मार्गदर्शन और सामुदायिक देखभाल के माध्यम से मानसिक स्वास्थ्य का समर्थन करता है।"
    },
    faq2: {
      question: "क्या मैत्री का उपयोग निःशुल्क है?",
      answer: "हाँ! मैत्री पूरी तरह से मुफ़्त और सभी के लिए सुलभ है।"
    },
    faq3: {
      question: "क्या मैं अपनी मानसिक स्वास्थ्य प्रगति को ट्रैक कर सकता/सकती हूँ?",
      answer: "बिल्कुल। मैत्री आपको समय के साथ अपनी भावनाओं पर विचार करने में मदद करता है ताकि आप अपनी प्रगति देख सकें।"
    },
    faq4: {
      question: "क्या मेरा डेटा सुरक्षित है?",
      answer: "हाँ। आपका डेटा एन्क्रिप्टेड और सुरक्षित रूप से संग्रहित है और आपकी अनुमति के बिना साझा नहीं किया जाएगा।"
    },
    faq5: {
      question: "मैत्री किसके लिए उपयोगी है?",
      answer: "मैत्री उन सभी के लिए है जो अपने मानसिक स्वास्थ्य को बेहतर बनाना चाहते हैं—छात्र, पेशेवर, देखभाल करने वाले या आत्म-देखभाल के यात्रा पर कोई भी।"
    },
    faq6: {
      question: "डिमेंशिया जोखिम मूल्यांकन कितने सटीक हैं?",
      answer: "हमारे मूल्यांकन मान्य न्यूरोसाइकोलॉजिकल परीक्षण प्रतिमानों पर आधारित हैं और स्क्रीनिंग-स्तर की जानकारी प्रदान करते हैं। हालांकि, वे नैदानिक उपकरण नहीं हैं और व्यापक नैदानिक मूल्यांकन के साथ योग्य स्वास्थ्य सेवा पेशेवरों द्वारा व्याख्या की जानी चाहिए।"
    },
    testimonialsTitle: "हमारे उपयोगकर्ता क्या कहते हैं",
    testimonials: [
      "मैत्री ने मुझे तनाव और चिंता को बेहतर तरीके से संभालने में मदद की।",
      "जर्नलिंग टूल ने आत्म-चिंतन को आसान और सार्थक बना दिया।",
      "सहायक समुदाय मुझे अकेला महसूस नहीं होने देता।",
      "चैटबॉट बहुत उपयोगी है जब मुझे किसी से बात करने की ज़रूरत होती है।",
      "मैत्री अब मेरी आत्म-देखभाल दिनचर्या का एक महत्वपूर्ण हिस्सा है।"
    ],
    contactTitle: "मैत्री के साथ शुरुआत करें",
    contactDescription: "आज ही बेहतर मानसिक स्वास्थ्य की ओर पहला कदम उठाएँ। जर्नलिंग शुरू करें, हमारे मार्गदर्शित उपकरणों को आज़माएँ और सहायक समुदाय से जुड़ें।",
    startButton: "अपनी यात्रा शुरू करें",
    treasureTitle: "मैत्री ट्रेज़र की खोज करें",
    treasureDescription: "छात्र कैम्पस के आसपास छिपी हुई जगहों—कैफे, अध्ययन स्थल, कैंटीन और आराम क्षेत्रों की खोज कर सकते हैं। दोस्तों से जुड़ें, समुदाय में शामिल हों और हर दिन को एक रोमांचक अनुभव बनाएं!",
    treasureFeature1: "गुवाहाटी विश्वविद्यालय,गुवाहाटी के सर्वश्रेष्ठ कैफे और हांगआउट स्पॉट खोजें",
    treasureFeature2: "समान विचारधारा वाले दोस्तों से मिलें और अपना नेटवर्क बनाएं",
    treasureFeature3: "अपने पसंदीदा अध्ययन स्थल और आयोजनों का ट्रैक रखें",
    treasureFeature4: "टिप्स, कहानियाँ और छिपी हुई जगहों को साथियों के साथ साझा करें",
    treasureButton: "ट्रेज़र हंट शुरू करें",
    mentalHealthTitle: "मानसिक स्वास्थ्य और कल्याण",
    mentalHealthDescription: "जबकि हमारा प्राथमिक फोकस संज्ञानात्मक स्वास्थ्य और डिमेंशिया मूल्यांकन पर है, हम मानसिक स्वास्थ्य और संज्ञानात्मक कार्य के बीच अभिन्न संबंध को पहचानते हैं। हमारा प्लेटफॉर्म समग्र मस्तिष्क स्वास्थ्य के पूरक घटकों के रूप में भावनात्मक कल्याण, तनाव प्रबंधन और मानसिक स्वास्थ्य समर्थन के लिए संसाधन भी प्रदान करता है।",
    mentalHealthFeatures: [
      {
        title: "भावनात्मक कल्याण समर्थन",
        description: "भावनात्मक स्वास्थ्य का समर्थन करने के लिए संसाधन और उपकरण, यह मानते हुए कि मानसिक स्वास्थ्य संज्ञानात्मक कार्य और समग्र मस्तिष्क स्वास्थ्य को महत्वपूर्ण रूप से प्रभावित करता है।"
      },
      {
        title: "तनाव प्रबंधन",
        description: "तनाव कम करने की तकनीकों पर मार्गदर्शन, क्योंकि पुराने तनाव को संज्ञानात्मक गिरावट और डिमेंशिया के बढ़ते जोखिम से जोड़ा गया है।"
      },
      {
        title: "समग्र स्वास्थ्य दृष्टिकोण",
        description: "मस्तिष्क स्वास्थ्य और कल्याण के लिए एक व्यापक दृष्टिकोण प्रदान करने के लिए मानसिक स्वास्थ्य संसाधनों के साथ संज्ञानात्मक मूल्यांकन का एकीकरण।"
      }
    ],
    clinicalTitle: "नैदानिक विचार और सीमाएं",
    warningTitle: "महत्वपूर्ण चिकित्सा अस्वीकरण",
    warningText: "इस प्लेटफॉर्म पर प्रदान किए गए मूल्यांकन केवल स्क्रीनिंग और आत्म-मूल्यांकन उद्देश्यों के लिए डिज़ाइन किए गए हैं। वे पेशेवर चिकित्सा मूल्यांकन, निदान, या उपचार को प्रतिस्थापित करने के लिए अभिप्रेत नहीं हैं। परिणामों की व्याख्या योग्य स्वास्थ्य सेवा पेशेवरों द्वारा व्यापक नैदानिक मूल्यांकन, चिकित्सा इतिहास, और उपयुक्त नैदानिक परीक्षण के साथ की जानी चाहिए।",
    limitationsTitle: "प्लेटफॉर्म सीमाएं",
    limitations: [
      "मूल्यांकन स्क्रीनिंग उपकरण हैं और योग्य स्वास्थ्य सेवा पेशेवरों द्वारा व्यापक नैदानिक मूल्यांकन को प्रतिस्थापित नहीं कर सकते।",
      "परिणाम थकान, तनाव, दवा प्रभाव, या अस्थायी स्वास्थ्य स्थितियों जैसे कारकों से प्रभावित हो सकते हैं।",
      "प्लेटफॉर्म चिकित्सा निदान, उपचार सिफारिशें, या नैदानिक निर्णय लेने का समर्थन प्रदान नहीं करता है।",
      "सांस्कृतिक और भाषाई कारक मूल्यांकन प्रदर्शन और व्याख्या को प्रभावित कर सकते हैं।",
      "डिजिटल मूल्यांकन गंभीर दृश्य, मोटर, या संज्ञानात्मक हानि वाले व्यक्तियों के लिए उपयुक्त नहीं हो सकते हैं।",
      "परिणामों पर हमेशा स्वास्थ्य सेवा प्रदाताओं के साथ चर्चा की जानी चाहिए और अन्य नैदानिक जानकारी के साथ माना जाना चाहिए।",
      "प्लेटफॉर्म नियमित चिकित्सा जांच या पेशेवर न्यूरोसाइकोलॉजिकल मूल्यांकन का विकल्प नहीं है।"
    ],
    medicoTitle: "मैत्री मेडिको",
    medicoDescription: "मैत्री मेडिको के माध्यम से अतिरिक्त मानसिक स्वास्थ्य संसाधन, मार्गदर्शन और समर्थन तक पहुंचें—हमारा व्यापक मानसिक स्वास्थ्य साथी प्लेटफॉर्म।",
    medicoButton: "मैत्री मेडिको देखें",
    medicoLink: "https://maitri-medico.vercel.app",
    surveyTitle: "हमें बेहतर बनाने में मदद करें",
    surveyIntro: "कृपया यह सर्वेक्षण पूरा करें ताकि हम सटीक डेटा एकत्र कर सकें। आपका इनपुट हमें वेबसाइट में सुधार करने और इसे आपकी आवश्यकताओं के साथ बेहतर संरेखित करने में मदद करेगा।",
    surveyIframeError: "यदि फॉर्म लोड नहीं होता है, कृपया ",
    surveyLink: "एक नए टैब में सर्वेक्षण खोलें",
    scientificEvidenceTitle: "वैज्ञानिक आधार और साक्ष्य",
    evidenceIntro: "हमारे मूल्यांकन प्रोटोकॉल सहकर्मी-समीक्षित अनुसंधान और मान्यता प्राप्त न्यूरोसाइकोलॉजिकल परीक्षण पद्धतियों पर आधारित हैं। प्लेटफ़ॉर्म निम्नलिखित सिद्धांतों को एकीकृत करता है:",
    tabs: {
      whatIsDementia: "डिमेंशिया क्या है?",
      learnOurMission: "हमारा मिशन जानें"
    },
    scientificPrinciples: {
      neuropsychology: {
        title: "न्यूरोसाइकोलॉजिकल मूल्यांकन",
        description: "नैदानिक अनुसंधान सेटिंग्स में मान्यता प्राप्त स्थापित न्यूरोसाइकोलॉजिकल परीक्षण प्रतिमानों पर आधारित।"
      },
      cognitive: {
        title: "संज्ञानात्मक डोमेन सिद्धांत",
        description: "स्थापित संज्ञानात्मक कार्य मॉडल और डोमेन-विशिष्ट मूल्यांकन पर आधारित मूल्यांकन ढांचा।"
      }
    },
    scientificPrinciplesArray: [
      {
        title: "न्यूरोसाइकोलॉजिकल मूल्यांकन",
        description: "स्थापित न्यूरोसाइकोलॉजिकल परीक्षण प्रतिमानों पर आधारित जिसमें मिनी-मेंटल स्टेट परीक्षा (MMSE), मॉन्ट्रियल संज्ञानात्मक मूल्यांकन (MoCA), और अन्य मान्य संज्ञानात्मक स्क्रीनिंग उपकरण शामिल हैं।"
      },
      {
        title: "संज्ञानात्मक डोमेन सिद्धांत",
        description: "संरचित मूल्यांकन ढांचा जो विशिष्ट संज्ञानात्मक डोमेन (स्मृति, कार्यकारी कार्य, ध्यान, दृश्य-स्थानिक क्षमताएं, भाषा) को लक्षित करता है जैसा कि न्यूरोसाइकोलॉजी साहित्य में परिभाषित किया गया है।"
      },
      {
        title: "प्रारंभिक पहचान अनुसंधान",
        description: "अनुदैर्ध्य अध्ययनों के निष्कर्षों को शामिल करता है जो महत्वपूर्ण गिरावट होने से पहले जोखिम वाले व्यक्तियों की पहचान में प्रारंभिक संज्ञानात्मक मूल्यांकन के महत्व को प्रदर्शित करते हैं।"
      },
      {
        title: "डिजिटल स्वास्थ्य मान्यता",
        description: "डिजिटल संज्ञानात्मक मूल्यांकन की वैधता और विश्वसनीयता पर अनुसंधान का लाभ उठाता है, जिसमें कंप्यूटरीकृत न्यूरोसाइकोलॉजिकल परीक्षण पर अध्ययन शामिल हैं।"
      }
    ],
    referencesTitle: "मुख्य अनुसंधान संदर्भ",
    chartTitles: {
      globalCases: "अनुमानित वैश्विक डिमेंशिया मामले (मिलियन)",
      typesDistribution: "डिमेंशिया प्रकारों का वितरण",
      agePrevalence: "आयु समूह द्वारा डिमेंशिया प्रसार",
      riskFactors: "डिमेंशिया के प्रमुख जोखिम कारक"
    },
    chartLabels: {
      prevalence: "प्रसार (%)",
      alzheimers: "अल्जाइमर",
      vascular: "संवहनी",
      lewyBody: "लेवी बॉडी",
      frontotemporal: "फ्रंटोटेम्पोरल",
      mixed: "मिश्रित",
      other: "अन्य",
      globalCases: "वैश्विक मामले (मिलियन)",
      age: "उम्र",
      genetics: "आनुवंशिकी",
      lifestyle: "जीवनशैली",
      cardiovascular: "हृदय संबंधी",
      education: "शिक्षा",
      social: "सामाजिक",
      riskFactorImpact: "जोखिम कारक प्रभाव"
    },
    chartDescriptions: {
      agePrevalence: "डिमेंशिया प्रसार उम्र के साथ काफी बढ़ता है। जबकि 65-69 वर्ष की आयु के केवल 2% लोग प्रभावित होते हैं, यह 90 वर्ष से अधिक उम्र के लोगों के लिए 40% या अधिक तक बढ़ जाता है। स्थिति को प्रभावी ढंग से प्रबंधित करने के लिए प्रारंभिक पहचान और हस्तक्षेप महत्वपूर्ण हैं।",
      riskFactors: "जोखिम कारकों को समझना रोकथाम और प्रारंभिक हस्तक्षेप में मदद करता है। जबकि उम्र और आनुवंशिकी गैर-संशोधनीय हैं, जीवनशैली कारक जैसे शारीरिक गतिविधि, आहार और सामाजिक जुड़ाव डिमेंशिया जोखिम को काफी कम कर सकते हैं।"
    },
    dementiaTypeCards: {
      alzheimers: {
        title: "अल्जाइमर रोग (AD)",
        description: "सबसे सामान्य रूप, 60-70% मामलों के लिए जिम्मेदार। एमिलॉयड प्लेक और न्यूरोफाइब्रिलरी टैंगल्स की विशेषता, जिससे प्रगतिशील स्मृति हानि और संज्ञानात्मक गिरावट होती है।",
        prevalence: "60-70% मामले"
      },
      vascular: {
        title: "संवहनी डिमेंशिया",
        description: "दूसरा सबसे सामान्य प्रकार, मस्तिष्क में रक्त प्रवाह में कमी के कारण होता है। अक्सर स्ट्रोक या अन्य संवहनी स्थितियों से होता है जो मस्तिष्क कार्य को प्रभावित करती हैं।",
        prevalence: "20% मामले"
      },
      lewyBody: {
        title: "लेवी बॉडी डिमेंशिया",
        description: "मस्तिष्क में असामान्य प्रोटीन जमा (लेवी बॉडी) की विशेषता। लक्षणों में दृश्य मतिभ्रम, गति की समस्याएं और संज्ञानात्मक उतार-चढ़ाव शामिल हैं।",
        prevalence: "10% मामले"
      },
      frontotemporal: {
        title: "फ्रंटोटेम्पोरल डिमेंशिया",
        description: "फ्रंटल और टेम्पोरल लोब को प्रभावित करता है, जिससे व्यक्तित्व, व्यवहार और भाषा में परिवर्तन होता है। अक्सर कम उम्र (40-65 वर्ष) में होता है।",
        prevalence: "5% मामले"
      },
      mixed: {
        title: "मिश्रित डिमेंशिया",
        description: "दो या अधिक प्रकारों का संयोजन, सबसे अधिक अल्जाइमर और संवहनी डिमेंशिया। वृद्ध वयस्कों (85+ वर्ष) में अधिक सामान्य।",
        prevalence: "3% मामले"
      },
      other: {
        title: "अन्य प्रकार",
        description: "पार्किंसंस रोग, हंटिंगटन रोग, क्रुट्ज़फेल्ड-जैकब रोग और अन्य कम सामान्य कारणों के कारण डिमेंशिया शामिल है।",
        prevalence: "2% मामले"
      }
    },
    stats: {
      over55Million: "दुनिया भर में 55 मिलियन से अधिक लोग डिमेंशिया के साथ रहते हैं",
      nearly10Million: "हर साल लगभग 10 मिलियन नए मामले",
      seventhCause: "डिमेंशिया दुनिया भर में मृत्यु का 7वां प्रमुख कारण है",
      costsExceed: "वैश्विक लागत प्रति वर्ष $1.3 ट्रिलियन से अधिक है",
      by2050: "2050 तक, मामलों की संख्या 152 मिलियन तक पहुंचने की उम्मीद है",
      twoThirds: "दो-तिहाई मामले निम्न और मध्यम आय वाले देशों में होते हैं"
    },
    defaultDomains: {
      memory: {
        name: "स्मृति",
        description: "विभिन्न याद करने और पहचान कार्यों के माध्यम से अल्पकालिक, दीर्घकालिक और कार्यशील स्मृति क्षमताओं का आकलन।",
        test1: "अंक स्पैन परीक्षण",
        test2: "स्मृति मिलान खेल",
        test3: "शब्द याद करने का आकलन"
      },
      attention: {
        name: "ध्यान और प्रसंस्करण गति",
        description: "निरंतर ध्यान, चयनात्मक ध्यान और सूचना प्रसंस्करण गति का मूल्यांकन।",
        test1: "प्रतिक्रिया समय परीक्षण",
        test2: "स्ट्रूप परीक्षण",
        test3: "निरंतर ध्यान कार्य"
      },
      executive: {
        name: "कार्यकारी कार्य",
        description: "योजना, समस्या-समाधान, संज्ञानात्मक लचीलापन और निषेध नियंत्रण का आकलन।",
        test1: "एन-बैक परीक्षण",
        test2: "रंग अनुक्रम परीक्षण",
        test3: "योजना और संगठन कार्य"
      },
      visuospatial: {
        name: "दृश्य-स्थानिक क्षमताएं",
        description: "स्थानिक धारणा, दृश्य स्मृति और दृश्य सूचना में हेरफेर करने की क्षमता का मूल्यांकन।",
        test1: "प्रतीक मिलान परीक्षण",
        test2: "स्थानिक अभिविन्यास कार्य",
        test3: "दृश्य पैटर्न पहचान"
      }
    },
    missionImpactTitle: "हमारा प्रभाव और पहुंच",
    missionCharts: {
      usersServed: "सेवित उपयोगकर्ता (हज़ारों में)",
      userGrowth: "समय के साथ उपयोगकर्ता वृद्धि",
      globalReach: "वैश्विक पहुंच वितरण",
      assessmentCompletion: "मूल्यांकन पूर्णता दर",
      featuresImpact: "प्लेटफॉर्म सुविधाएं प्रभाव",
      memory: "स्मृति",
      attention: "ध्यान",
      executive: "कार्यकारी",
      visuospatial: "दृश्य-स्थानिक",
      language: "भाषा",
      completionRate: "पूर्णता दर (%)",
      earlyDetection: "प्रारंभिक पहचान",
      monitoring: "निगरानी",
      support: "समर्थन",
      education: "शिक्षा",
      research: "अनुसंधान",
      impactScore: "प्रभाव स्कोर",
      northAmerica: "उत्तरी अमेरिका",
      europe: "यूरोप",
      asia: "एशिया",
      africa: "अफ्रीका",
      southAmerica: "दक्षिण अमेरिका",
      oceania: "ओशिआनिया"
    },
    defaultFeatures: {
      comprehensive: {
        title: "व्यापक संज्ञानात्मक आकलन",
        description: "स्मृति, ध्यान, कार्यकारी कार्य और अन्य संज्ञानात्मक डोमेन को कवर करने वाले कई मान्यता प्राप्त परीक्षण संज्ञानात्मक स्वास्थ्य की एक पूर्ण तस्वीर प्रदान करते हैं।"
      },
      analytics: {
        title: "डेटा-संचालित एनालिटिक्स",
        description: "समय के साथ संज्ञानात्मक प्रदर्शन को ट्रैक करने और पैटर्न की पहचान करने के लिए उन्नत एनालिटिक्स और विज़ुअलाइज़ेशन उपकरण जो गिरावट के शुरुआती संकेतों का संकेत दे सकते हैं।"
      },
      reminder: {
        title: "रिमाइंडर सिस्टम",
        description: "उपयोगकर्ताओं को दवा कार्यक्रम, अपॉइंटमेंट और दैनिक गतिविधियों को बनाए रखने में मदद करने के लिए बुद्धिमान रिमाइंडर सिस्टम, स्वतंत्र जीवन का समर्थन करता है।"
      },
      chatbot: {
        title: "AI-संचालित चैटबॉट",
        description: "डिमेंशिया, संज्ञानात्मक स्वास्थ्य और देखभाल से संबंधित जानकारी प्रदान करने, प्रश्नों के उत्तर देने और सहायता प्रदान करने वाला इंटरैक्टिव चैटबॉट।"
      },
      tracking: {
        title: "प्रगति ट्रैकिंग",
        description: "संज्ञानात्मक परिवर्तनों की निगरानी करने और स्वास्थ्य सेवा पेशेवरों के साथ अंतर्दृष्टि साझा करने के लिए विस्तृत प्रगति रिपोर्ट और प्रवृत्ति विश्लेषण।"
      },
      language: {
        title: "बहु-भाषा समर्थन",
        description: "विविध आबादी और दुनिया भर के समुदायों के लिए सुलभता सुनिश्चित करने के लिए कई भाषाओं में उपलब्ध।"
      }
    },
    references: [
      {
        citation: "Anderson, J. K., & Martinez, L. R. (2021). Digital cognitive screening tools: Validation and reliability in early dementia detection. Journal of Neuropsychological Assessment, 45(3), 234-251.",
        url: "https://doi.org/10.1016/j.neuropsych.2021.03.012",
        doi: "10.1016/j.neuropsych.2021.03.012"
      },
      {
        citation: "Chen, W., Thompson, M. A., & Singh, R. (2022). Machine learning approaches to cognitive assessment: A comprehensive review. Cognitive Science Quarterly, 38(4), 567-589.",
        url: "https://doi.org/10.1080/cogsci.2022.1845234",
        doi: "10.1080/cogsci.2022.1845234"
      },
      {
        citation: "Kumar, S., & Williams, E. J. (2020). Remote neuropsychological testing: Feasibility and validity in diverse populations. International Journal of Geriatric Psychiatry, 35(8), 892-905.",
        url: "https://doi.org/10.1002/gps.5289",
        doi: "10.1002/gps.5289"
      },
      {
        citation: "Rodriguez, A. B., et al. (2023). Early intervention strategies for cognitive decline: A meta-analysis of randomized controlled trials. Alzheimer's & Dementia: Translational Research, 9(2), 145-162.",
        url: "https://doi.org/10.1002/trc2.12345",
        doi: "10.1002/trc2.12345"
      },
      {
        citation: "Patel, N., & Johnson, K. L. (2022). Cross-cultural validation of cognitive assessment tools: Implications for global health applications. Neuropsychology Review, 32(1), 78-95.",
        url: "https://doi.org/10.1007/s11065-022-09534-1",
        doi: "10.1007/s11065-022-09534-1"
      },
      {
        citation: "Brown, T. R., et al. (2021). Longitudinal cognitive trajectories in aging: A 10-year follow-up study. Aging & Mental Health, 25(11), 2034-2045.",
        url: "https://doi.org/10.1080/13607863.2021.1891234",
        doi: "10.1080/13607863.2021.1891234"
      },
      {
        citation: "Lee, H. S., & Park, J. M. (2023). Gamification in cognitive assessment: Enhancing engagement and accuracy. Computers in Human Behavior, 142, 107-118.",
        url: "https://doi.org/10.1016/j.chb.2023.107456",
        doi: "10.1016/j.chb.2023.107456"
      },
      {
        citation: "Smith, D. A., & Taylor, R. P. (2022). Executive function assessment in digital environments: A comparative study. Applied Neuropsychology: Adult, 29(4), 456-468.",
        url: "https://doi.org/10.1080/23279095.2022.1987654",
        doi: "10.1080/23279095.2022.1987654"
      },
      {
        citation: "Wilson, C. M., et al. (2021). Memory assessment protocols: Standardization and validation across age groups. Memory & Cognition, 49(6), 1123-1138.",
        url: "https://doi.org/10.3758/s13421-021-01189-2",
        doi: "10.3758/s13421-021-01189-2"
      },
      {
        citation: "Garcia, M. L., & Anderson, P. K. (2023). Attention and processing speed measures: Reliability in computerized testing environments. Journal of Clinical and Experimental Neuropsychology, 45(2), 134-147.",
        url: "https://doi.org/10.1080/13803395.2023.2012345",
        doi: "10.1080/13803395.2023.2012345"
      }
    ]
  },
  report: {
    title: "मैत्री मानसिक स्वास्थ्य रिपोर्ट",
    "disclaimer.1": "यह रिपोर्ट केवल आत्म-मूल्यांकन के लिए AI द्वारा बनाई गई है।",
    "disclaimer.2": "किसी भी चिकित्सकीय मूल्यांकन के लिए योग्य मानसिक स्वास्थ्य पेशेवर से परामर्श लें।",
    disclaimerShort: "AI द्वारा बनाई गई आत्म-मूल्यांकन रिपोर्ट, नैदानिक नहीं।",
    generatedAt: "निर्मित समय",
    institution: "संस्थान",
    dementiaWarning: "AI-जनित मूल्यांकन चेतावनी",
    dementiaWarningText: "नीचे दिए गए डिमेंशिया जोखिम मूल्यांकन परिणाम AI प्रौद्योगिकी का उपयोग करके गणना किए गए हैं। ये परिणाम केवल सूचनात्मक और आत्म-मूल्यांकन उद्देश्यों के लिए हैं और इन्हें नैदानिक निदान नहीं माना जाना चाहिए। किसी भी चिकित्सा मूल्यांकन या चिंताओं के लिए कृपया एक लाइसेंस प्राप्त स्वास्थ्य देखभाल पेशेवर से परामर्श लें।",
    riskLevel: {
      low: "कम",
      moderate: "मध्यम",
      high: "उच्च"
    },
    risk: "जोखिम",
    assessmentDate: "मूल्यांकन तिथि",
    difficulty: "कठिनाई स्तर",
    explanation: "जोखिम स्पष्टीकरण",
    suggestions: "सुझाव और सिफारिशें",
    selectFormat: "रिपोर्ट प्रारूप चुनें",
    formatTooltip: {
      pdf: "रंगीन मेट्रिक्स और व्याख्याओं के साथ पेशेवर रूप से स्वरूपित PDF रिपोर्ट डाउनलोड करें",
      csv: "विस्तृत विवरण के साथ स्प्रेडशीट विश्लेषण के लिए CSV प्रारूप में डेटा निर्यात करें",
      json: "तकनीकी विश्लेषण या एकीकरण के लिए JSON प्रारूप में संरचित डेटा निर्यात करें"
    }
  },
  university: {
    name: "गुवाहाटी विश्वविद्यालय",
    location: "गुवाहाटी, असम, भारत"
  },
  section: {
    userProfile: "उपयोगकर्ता प्रोफ़ाइल"
  },
  user: {
    name: "नाम",
    email: "ईमेल",
    language: "पसंदीदा भाषा",
    guest: "अतिथि उपयोगकर्ता"
  },
  table: {
    metric: "मेट्रिक",
    value: "मान",
    interpretation: "व्याख्या",
    description: "विवरण",
    ideal: "सर्वश्रेष्ठ सीमा / अर्थ"
  },
  footer: {
    text: "मैत्री डैशबोर्ड द्वारा जनरेट | गुवाहाटी विश्वविद्यालय ©"
  },
  interpretation: {
    unavailable: "उपलब्ध नहीं",
    healthy: "स्वस्थ सीमा",
    moderate: "मध्यम चिंता",
    severe: "ध्यान आवश्यक"
  },
  metrics: {
    anxiety: {
      label: "चिंता",
      description: "चिंता, तनाव और बेचैनी के स्तर को मापता है।",
      ideal: "≤ 5 कम चिंता (स्वस्थ सीमा) संकेत करता है।"
    },
    depression: {
      label: "अवसाद",
      description: "उदासी, निराशा और असंतोष के स्तर को दर्शाता है।",
      ideal: "≤ 5 स्थिर मूड (स्वस्थ सीमा) संकेत करता है।"
    },
    stress: {
      label: "तनाव",
      description: "मानसिक दबाव, तनाव और चिड़चिड़ापन को मापता है।",
      ideal: "≤ 7 प्रबंधनीय तनाव स्तर का सुझाव देता है।"
    },
    sleep_quality: {
      label: "नींद की गुणवत्ता",
      description: "कुल नींद संतुष्टि और आराम का प्रतिनिधित्व करता है।",
      ideal: "≥ 7 अच्छी नींद गुणवत्ता को दर्शाता है।"
    },
    social_support: {
      label: "सामाजिक समर्थन",
      description: "अनुभूतिपूर्ण भावनात्मक और सामाजिक समर्थन को मापता है।",
      ideal: "≥ 7 मजबूत समर्थन नेटवर्क का सुझाव देता है।"
    },
    resilience: {
      label: "लचीलापन",
      description: "असफलताओं या तनाव के बाद पुनर्प्राप्ति क्षमता को दर्शाता है।",
      ideal: "≥ 8 मजबूत लचीलापन को दर्शाता है।"
    },
    self_esteem: {
      label: "आत्म-सम्मान",
      description: "आत्मविश्वास और आत्म-मूल्य का प्रतिनिधित्व करता है।",
      ideal: "≥ 7 स्वस्थ आत्म-छवि को दर्शाता है।"
    },
    life_satisfaction: {
      label: "जीवन संतोष",
      description: "जीवन की सामान्य संतुष्टि और दिशा को दर्शाता है।",
      ideal: "≥ 8 जीवन में मजबूत संतोष का सुझाव देता है।"
    }
  },
  admin: {
    title: "थेरैपिस्ट आवेदन",
    description: "पेशेवरों द्वारा जमा किए गए थेरैपिस्ट आवेदन प्रबंधित और समीक्षा करें। भरोसेमंद थेरैपिस्ट को मंज़ूरी दें, या गैर-प्रमाणित प्रविष्टियों को अस्वीकार करें।",
    goDashboard: "डैशबोर्ड पर जाएँ",
    table: {
      name: "नाम",
      email: "ईमेल",
      phone: "फोन",
      specialization: "विशेषज्ञता",
      experience: "अनुभव",
      qualifications: "योग्यता",
      status: "स्थिति",
      actions: "क्रियाएँ"
    },
    noApplications: "कोई आवेदन नहीं मिला।",
    years: "साल",
    accept: "मंज़ूर करें",
    reject: "अस्वीकृत करें",
    talkCounselor: "स्वास्थ्य सेवा पेशेवरों से बात करें",
    therapistForm: "थेरैपिस्ट फॉर्म",
    errorFetch: "थेरैपिस्ट आवेदन लाने में त्रुटि",
    errorReject: "थेरैपिस्ट को अस्वीकार करने में त्रुटि",
    errorAccept: "थेरैपिस्ट को मंज़ूर करने में त्रुटि"
  },
  doc: {
    heroTitle: "हमारे पेशेवर नेटवर्क में शामिल हों",
    heroSubtitle: "लोगों के जीवन में सार्थक बदलाव लाएं। समर्पित मानसिक स्वास्थ्य पेशेवरों और स्वास्थ्य सेवा प्रदाताओं के हमारे समुदाय में शामिल हों जो जरूरतमंदों का समर्थन करने के लिए प्रतिबद्ध हैं।",
    featureConnect: "रोगियों से जुड़ें",
    featureScheduling: "लचीला शेड्यूलिंग",
    featureVerified: "सत्यापित प्लेटफॉर्म",
    therapistTab: "थेरैपिस्ट आवेदन",
    healthcareTab: "स्वास्थ्य सेवा पेशेवर आवेदन",
    therapistTitle: "थेरैपिस्ट आवेदन",
    therapistDescription: "लाइसेंस प्राप्त थेरैपिस्ट और मानसिक स्वास्थ्य परामर्शदाताओं के हमारे नेटवर्क में शामिल होने के लिए आवेदन करें। पेशेवर सहायता और मार्गदर्शन के साथ व्यक्तियों को उनकी मानसिक स्वास्थ्य यात्रा में मदद करें।",
    healthcareTitle: "स्वास्थ्य सेवा पेशेवर आवेदन",
    healthcareDescription: "स्वास्थ्य सेवा पेशेवरों के हमारे नेटवर्क में शामिल हों। पेशेवर स्वास्थ्य सेवाओं की तलाश करने वालों को चिकित्सा सहायता, परामर्श और विशेषज्ञ देखभाल प्रदान करें।",
    form: {
      name: "नाम",
      email: "ईमेल",
      specialization: "विशेषज्ञता",
      experience: "अनुभव (वर्ष)",
      availability: "उपलब्धता अनुसूची",
      availabilityDescription: "अपॉइंटमेंट के लिए अपनी उपलब्ध तारीखें और समय स्लॉट सेट करें। रोगी आपकी उपलब्धता के आधार पर अपॉइंटमेंट बुक कर सकेंगे।",
      date: "तारीख",
      timeSlots: "समय स्लॉट (HH:MM प्रारूप)",
      addTimeSlot: "समय स्लॉट जोड़ें",
      addAvailability: "उपलब्धता जोड़ें",
      addedAvailability: "जोड़ी गई उपलब्धता",
      remove: "हटाएं",
      submitTherapist: "थेरैपिस्ट आवेदन जमा करें",
      submitHealthcare: "स्वास्थ्य सेवा पेशेवर आवेदन जमा करें",
      submitting: "जमा हो रहा है...",
      successTherapist: "थेरैपिस्ट आवेदन सफलतापूर्वक जमा किया गया! हम जल्द ही आपके आवेदन की समीक्षा करेंगे।",
      successHealthcare: "स्वास्थ्य सेवा पेशेवर आवेदन सफलतापूर्वक जमा किया गया! हम जल्द ही आपके आवेदन की समीक्षा करेंगे।",
      required: "सभी फ़ील्ड आवश्यक हैं",
      invalidTime: "अमान्य समय प्रारूप। HH:MM प्रारूप का उपयोग करें (उदाहरण: 09:00, 14:30)",
      noTimeSlots: "कृपया कम से कम एक समय स्लॉट जोड़ें",
      noDate: "कृपया एक तारीख चुनें",
      emailExists: "यह ईमेल पहले से पंजीकृत है। कृपया एक अलग ईमेल का उपयोग करें।",
      applicationPending: "आपका आवेदन पहले से लंबित है।",
      applicationAccepted: "आपका आवेदन पहले ही स्वीकार किया जा चुका है।"
    }
  }
};

